import React, { useMemo, useState } from "react";

import { useNavigate } from "react-router-dom";

import {

  generateTechTeamReport,

  generateBloodFixPdf,
  advancedTechTeamReport,

} from "../services/api";



const REPORT_TYPES = [

  { key: "normal_case", label: "Normal Case" },

  { key: "add_comp", label: "Add Comp" },

  { key: "outstanding_result_drugs", label: "Outstanding Result Drugs" },

  { key: "outstanding_result_alcohol", label: "Outstanding Result Alcohol" },

  { key: "external_results", label: "External Results" },

  { key: "questions", label: "Questions" },

  { key: "certis", label: "Certis" },

  { key: "atto", label: "Atto" },

];



const AUTOREPORT_TYPES = new Set(["normal_case", "add_comp", "certis", "atto"]);



// External Results keeps its existing PDF-derived narrative/template,

// but requires the raw analytical JSON as a safety source for complete section

// structure/results (e.g. 12-section scalp tables where PDF extraction may lose

// sections 9-12).

const JSON_REQUIRED_TYPES = new Set([

  ...AUTOREPORT_TYPES,

  "external_results",

  "outstanding_result_drugs",

]);



const EXPERT_NAMES = [

  "Lewis Simcoates",

  "Dominic Fisher",

  "Joe Moxon",

  "Daniel Beverley",

  "Damian World",

  "Mark Davies",

  "Tasheka Cousins",

  "Beth Braithwaite",

];



// Atto-specific author; other report types keep their existing options.
const ATTO_EXPERT_NAMES = [...EXPERT_NAMES, "Mathew Wade"];

const INFLUENCES = [

  "Hair Dye",

  "Thermals",

  "Natural Hair Colour",

  "Pregnancy",

  "UV",

  "Previous Site",

  "Growth Rate Calculated",

  "Swimming",

  "Nail Influences",

  "Nail Pregnancy",

  "EtPa Influences",

];



const ATTO_DYE_RELATIVE_OPTIONS = [

  "1 week prior",

  "2 weeks prior",

  "3 weeks prior",

  "1 month prior",

  "2 months prior",

  "3 months prior",

  "4 months prior",

  "5 months prior",

  "6 months prior",

  "7 months prior",

  "8 months prior",

  "9 months prior",

  "10 months prior",

  "11 months prior",

  "12 months prior",

  "Unknown",

];



const SAMPLE_STORAGE_OPTIONS = [

  "Right arm hair",

  "Left arm hair",

  "Right leg hair",

  "Left leg hair",

  "Chest hair",

  "Back hair",

  "Abdominal hair",

  "Facial hair",

  "Pubic hair",

  "Right axillary hair",

  "Left axillary hair",

  "Other body hair",

  "Fingernail clippings",

  "Toenail clippings",

  "Finger-prick blood sample for PEth",

];

function attoJsonTestingProfile(data) {
  const profile = {
    alcohol: false,
    nailAlcohol: false,
    nailDrugs: false,
    bodyHairAlcohol: false,
    bodyHairDrugs: false,
    pethPresent: false,
    cdtPresent: false,
    lftsPresent: false,
    mcvPresent: false,
    amphetaminePanelPresent: false,
    cocainePanelPresent: false,
  };

  if (!data || typeof data !== "object") {
    return profile;
  }

  const tests = Array.isArray(data.tests) ? data.tests : data.tests ? [data.tests] : [];
  profile.alcohol = tests.some((value) =>
    /\b(alcohol|etg|etpa|faee|peth|cdt|lft|mcv)\b/i.test(String(value || ""))
  );
  profile.amphetaminePanelPresent = tests.some((value) => {
    const token = String(value || "").toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
    return token === "methamphetamine_incl_amphetamine" || token === "methamphetamine";
  });
  profile.cocainePanelPresent = tests.some((value) => {
    const token = String(value || "").toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
    return token === "cocaine";
  });

  const classifyResult = (name) => {
    const value = String(name || "");

    const alcoholHair =
      /ethyl glucuronide|\betg\b|ethyl palmitate|fatty acid ethyl ester|\betpa\b|\bfaee\b/i.test(
        value
      );
    const peth =
      /phosphatidylethanol|\bpeth\b/i.test(value);
    const cdt =
      /\bcdt\b|carbohydrate[- ]?deficient transferrin/i.test(value);
    const lft =
      /\balt\b|\bast\b|\bggt\b|alanine|aspartate|gamma.?glutamyl/i.test(value);
    const mcv =
      /\bmcv\b|mean corpuscular volume|mean cell volume/i.test(value);

    return { alcoholHair, peth, cdt, lft, mcv };
  };

  for (const sample of Array.isArray(data.samples) ? data.samples : []) {
    const sampleType = String(sample?.sample_type || "").toLowerCase();
    const isNail = sampleType.includes("nail");
    const isBodyHair = sampleType.includes("hair") && !sampleType.includes("scalp");

    for (const testSample of Array.isArray(sample?.test_samples) ? sample.test_samples : []) {
      for (const result of Array.isArray(testSample?.results) ? testSample.results : []) {
        const name = result?.testable_name || result?.name || "";
        const resultType = classifyResult(name);
        if (/\bcocaine\b|benzoylecgonine|norcocaine|cocaethylene|hydroxybenzoylecgonine|anhydroecgonine/i.test(String(name || ""))) {
          profile.cocainePanelPresent = true;
        }

        if (
          resultType.alcoholHair ||
          resultType.peth ||
          resultType.cdt ||
          resultType.lft ||
          resultType.mcv
        ) {
          profile.alcohol = true;
        }

        if (resultType.peth) profile.pethPresent = true;
        if (resultType.cdt) profile.cdtPresent = true;
        if (resultType.lft) profile.lftsPresent = true;
        if (resultType.mcv) profile.mcvPresent = true;

        if (isNail) {
          if (resultType.alcoholHair) {
            profile.nailAlcohol = true;
          } else if (!(resultType.peth || resultType.cdt || resultType.lft || resultType.mcv)) {
            profile.nailDrugs = true;
          }
        }

        if (isBodyHair) {
          if (resultType.alcoholHair) {
            profile.bodyHairAlcohol = true;
          } else if (!(resultType.peth || resultType.cdt || resultType.lft || resultType.mcv)) {
            profile.bodyHairDrugs = true;
          }
        }
      }
    }
  }

  return profile;
}




const BLOOD_OPTIONS = [

  "None",

  "CDT, LFTs and MCV",

  "CDT only",

  "CDT and LFTs",

  "MCV only",

  "LFTs only",

];



const CANNABIS_OPTIONS = [

  "No",

  "Occasional",

  "Recent Abstinence",

  "Frequent",

  "Daily",

];



const PREVIOUS_DOA_OPTIONS = [

  "No",

  "Exposure",

  "Low use",

  "High use",

];



const THERMAL_OPTIONS = ["Unknown", "Yes", "No"];



const LINKED_CASE_OPTIONS = [

  "No",

  "Exposure",

  "Low use",

  "High use",

];



const ALCOHOL_OPTIONS = [

  "Abstinence",

  "Low",

  "Moderate",

  "Borderline",

  "Excessive",

];



const PREVIOUS_SCALP_SITE_OPTIONS = [

  { value: "No", label: "None" },

  { value: "Drugs only", label: "Drugs only" },

  { value: "Alcohol only", label: "Alcohol only" },

  { value: "Drugs and alcohol", label: "Drugs and alcohol" },

];



const PREVIOUS_SITE_GROWTH_OPTIONS = [

  "Average",

  "Quicker than average",

  "Slower than average",

];



const MEDICATION_OPTIONS = [

  "None",

  "Prescribed and non-prescribed",

  "Only prescribed",

  "Only non-prescribed",

];



const DEFAULT_OVERRIDES = {

  samples_stored: [],

  blood_selection: "None",

  peth_instructed: "No",

  cannabis_use: "No",

  previous_doa: "No",

  thermal_straightening: "Unknown",

  linked_case: "No",

  alcohol_usage: "Low",

  previous_scalp_site: "No",

  previous_site_growth: "Average",

  medications: "None",

};



function matchOption(value, options, fallback) {

  const source = String(value ?? "").trim().toLowerCase();



  const match = options.find((option) => {

    const optionValue =

      typeof option === "string"

        ? option

        : option.value;



    return String(optionValue).toLowerCase() === source;

  });



  if (!match) {

    return fallback;

  }



  return typeof match === "string"

    ? match

    : match.value;

}





function attoJsonHasCannabisTesting(data) {

  if (!data || typeof data !== "object") {

    return false;

  }



  const cannabisPattern =

    /\b(cannabis|cannabinoid|thc|delta[-\s]?9[-\s]?thc|tetrahydrocannabinol|cbd|cannabidiol|cbn|cannabinol)\b/i;



  const tests = Array.isArray(data.tests)

    ? data.tests

    : data.tests

      ? [data.tests]

      : [];



  if (tests.some((item) => cannabisPattern.test(String(item || "")))) {

    return true;

  }



  const samples = Array.isArray(data.samples) ? data.samples : [];

  for (const sample of samples) {

    const testSamples = Array.isArray(sample?.test_samples)

      ? sample.test_samples

      : [];



    for (const testSample of testSamples) {

      const results = Array.isArray(testSample?.results)

        ? testSample.results

        : [];



      for (const result of results) {

        const label = [

          result?.testable_name,

          result?.name,

          result?.analyte,

          result?.group_name,

        ]

          .filter(Boolean)

          .join(" ");



        if (cannabisPattern.test(label)) {

          return true;

        }

      }

    }

  }



  return false;

}



const ADV_USE_FREQ = ["one or two days each month", "a few days each month", "several days each month", "a few days each week", "daily"];
const ADV_DYED_USE_FREQ = ["multiple occasions", "at least several occasions", "a few days each week", "daily"];
const ADV_EXPOSURE_FREQ = ["minimal exposure", "regular exposure", "frequent and persistent passive exposure"];
const ADV_TYPES = [
  ["unreviewed","Select expert interpretation…"], ["use","Use"], ["exposure","Exposure"],
  ["two_equally_likely","Two equally likely"], ["insufficient_dye","Insufficient evidence — dye"],
  ["insufficient","Insufficient evidence"], ["abstinence","Abstinence"], ["non_use","Non-use"]
];
function advApproxDate(iso) {
  // FTS reporting dates use early/mid/late month, not laboratory ISO dates.
  // These are approximate labels based on the supplied JSON boundaries.
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso||""));
  if (!match) return iso || "";
  const day=Number(match[3]);
  const month=new Date(Date.UTC(Number(match[1]),Number(match[2])-1,1))
    .toLocaleString("en-GB",{month:"long",timeZone:"UTC"});
  return `${day<=10?"early":day<=20?"mid":"late"} ${month} ${match[1]}`;
}
function advFormatRange(units) {
  const starts=units.map(u=>u.start_date).filter(Boolean).sort();
  const ends=units.map(u=>u.end_date).filter(Boolean).sort();
  if (starts.length && ends.length) return `${advApproxDate(starts[0])} to ${advApproxDate(ends[ends.length-1])}`;
  return units.map(u=>u.period).filter(Boolean).join(" / ");
}
function advCanGroupUnits(previous, current) {
  if (!previous || !current) return false;
  // A scalp segment's barcode is NOT the parent sample ID: each section
  // normally has its own barcode. Group within the same parent sample only.
  return previous.sample_index === current.sample_index &&
    /scalp/i.test(String(current.matrix||"")) &&
    previous.matrix === current.matrix &&
    (()=>{
      const a=/Section\s+(\d+)/i.exec(String(previous.label||""));
      const b=/Section\s+(\d+)/i.exec(String(current.label||""));
      return a&&b ? Number(b[1])===Number(a[1])+1 :
        current.test_sample_index===previous.test_sample_index+1;
    })();
}
function advSameDecision(a,b) {
  return !!a && !!b && a.type!=="unreviewed" && a.type===b.type &&
    (a.frequency||"")===(b.frequency||"") &&
    (a.exposure_frequency||"")===(b.exposure_frequency||"") &&
    (a.reason||"")===(b.reason||"");
}
function advBuildPeriodGroups(drug) {
  const units=drug.units||[]; const decisions=drug.decisions||[];
  const groups=[];
  units.forEach((unit,i)=>{
    const d=decisions.find(x=>x.id===unit.id)||{};
    const previous=groups[groups.length-1];
    const last=previous?.units[previous.units.length-1];
    const canGroup=!!d.group_previous && previous && advCanGroupUnits(last,unit)
      && advSameDecision(previous,d);
    if(canGroup) previous.units.push(unit);
    else groups.push({type:d.type||"unreviewed",frequency:d.frequency||"",
      exposure_frequency:d.exposure_frequency||"",reason:d.reason||"",units:[unit]});
  });
  return groups.map(g=>({...g, period:advFormatRange(g.units)}));
}
function advBuildPeriods(drug) {
  return advBuildPeriodGroups(drug).map(({units,...p})=>({...p,
    section_label:advGroupLabel(units)}));
}
function advGroupLabel(units) {
  if(!units.length)return "Sample";
  const start=units[0];const end=units[units.length-1];
  const scalp=/scalp/i.test(start.matrix||"");
  const a=/Section\s*(\d+)/i.exec(start.label||"");
  const b=/Section\s*(\d+)/i.exec(end.label||"");
  if(scalp&&a&&b)return units.length===1?`Section ${a[1]}`:`Sections ${a[1]}–${b[1]}`;
  return units.length===1?(start.label||start.matrix||"Sample"):`${start.label}–${end.label}`;
}
function advSetGroupEnd(drug, group, targetUnitId) {
  const units=drug.units||[];
  const start=units.findIndex(x=>x.id===group.units[0]?.id);
  const end=units.findIndex(x=>x.id===targetUnitId);
  if(start<0||end<start)return drug.decisions||[];
  const original=drug.decisions||[];
  const decisions=original.map(x=>({...x}));
  const leader=decisions.find(x=>x.id===units[start].id)||{};
  // Preserve decisions outside the selected range. A newly selected endpoint
  // explicitly terminates this group; later groups stay independent.
  for(let i=start;i<=end;i++) {
    if(i>start && !advCanGroupUnits(units[i-1],units[i]))break;
    const item=decisions.find(x=>x.id===units[i].id);
    if(item)Object.assign(item,{type:leader.type,frequency:leader.frequency||"",
      exposure_frequency:leader.exposure_frequency||"",reason:leader.reason||"",group_previous:i>start});
  }
  if(end+1<units.length) {
    const next=decisions.find(x=>x.id===units[end+1].id);
    if(next)next.group_previous=false;
  }
  return decisions;
}
function advNaturalJoin(items) {
  if(items.length<2)return items[0]||"";
  if(items.length===2)return `${items[0]} and ${items[1]}`;
  return `${items.slice(0,-1).join(", ")}, and ${items[items.length-1]}`;
}
function advUsePhrase(freq,group) {
  const str=String(freq||"").trim();
  const single=group.units.length===1 && /scalp/i.test(group.units[0].matrix||"");
  // For a single one-month scalp section do not claim repetition each month.
  let wording=single?str.replace(/\s+each month\b/gi,"").trim():str;
  wording=wording.replace(/^on\s+/i,"");
  if(!wording)return "at an unquantified frequency";
  if(single && /^a few days$/i.test(wording))return "at least a few days";
  if(single && /^one or two days$/i.test(wording))return "around one or two days";
  if(single && /^several days$/i.test(wording))return "several days";
  return wording;
}
function advBuildNarrative(drug, periods) {
  const groups=advBuildPeriodGroups(drug);
  if(!groups.length)return drug.auto_interpretation||"";
  if(groups.some(g=>g.type==="unreviewed"))return "Review each interpretation group below to generate a draft opinion.";
  const name=String(drug.name||"the drug").toLowerCase();
  // The form of cocaine belongs in the detailed assessment unless explicitly
  // reviewed; a section-level opinion should not insert a speculative form.
  const range=g=>`around ${g.period||"the period represented by the sample"}`;
  const chronological=arr=>[...arr].sort((a,b)=>
    String(a.units[0]?.start_date||"").localeCompare(String(b.units[0]?.start_date||"")));
  const use=chronological(groups.filter(g=>g.type==="use"));
  const exposure=chronological(groups.filter(g=>g.type==="exposure"));
  const insufficient=chronological(groups.filter(g=>g.type==="insufficient"||g.type==="insufficient_dye"));
  const other=groups.filter(g=>!["use","exposure","insufficient","insufficient_dye"].includes(g.type));
  let paragraphs=[];
  if(use.length) {
    const clauses=use.map(g=>`on ${advUsePhrase(g.frequency,g)} during ${range(g)}`);
    paragraphs.push(`In my opinion, these findings are more likely than not to represent the use of ${name} ${advNaturalJoin(clauses)}.`);
  }
  if(exposure.length) {
    const clauses=exposure.map(g=>`${g.frequency||"passive exposure"} during ${range(g)}`);
    paragraphs.push(`${use.length?"In addition, the findings":"In my opinion, the findings"} are more likely than not to represent ${advNaturalJoin(clauses)} to ${name}.`);
  }
  if(insufficient.length) {
    const clauses=insufficient.map(g=>range(g));
    paragraphs.push(`${paragraphs.length?"However, in":"In"} my experience, these findings do not provide sufficient evidence to indicate the use of ${name} during ${advNaturalJoin(clauses)}.`);
  }
  for(const g of other) {
    if(g.type==="two_equally_likely")paragraphs.push(`In my opinion, use of ${name} ${g.frequency?`on ${g.frequency} `:""}and ${g.exposure_frequency||"passive exposure"} are two equally likely explanations for the findings during ${range(g)}.`);
    if(g.type==="abstinence")paragraphs.push(`The findings may be consistent with abstinence from ${name} during ${range(g)}, subject to the limitations discussed below.`);
    if(g.type==="non_use")paragraphs.push(`No evidence of ${name} use was identified during ${range(g)}; this does not exclude all use.`);
  }
  // Reasons influence suggested justifications, not automatic scientific
  // assertions. Carry-over cannot be inferred from a UI dropdown alone.
  return paragraphs.join("\n\n");
}
function advBuildFinalSummary(draft) {
  if (!draft) return "";
  const name=draft.client_name||"the client";
  const categories={use:[],exposure:[],unable:[],non_use:[]};
  const titles={use:[],exposure:[],unable:[],non_use:[]};
  const describe=(d)=>{
    const src=d.review_mode==="sections" ? (d.periods||[]) : (d.original_periods||d.periods||[]);
    let ps=src.filter(p=>p&&typeof p==="object"&&p.type);
    if(!ps.length){
      let scenario=String(d.summary_auto_scenario||d.auto_scenario||"").toLowerCase();
      const kind=scenario.includes("exposure")?"exposure":scenario.includes("use")?"use":scenario.includes("abstin")?"abstinence":scenario.includes("inconclus")||scenario.includes("insufficient")?"insufficient":"unclassified";
      ps=[{type:kind,frequency:d.summary_auto_frequency||d.frequency||"",period:d.summary_auto_period||d.date_range||""}];
    }
    return ps;
  };
  for(const d of draft.drugs||[]){
    const ps=describe(d),use=ps.filter(p=>p.type==="use"),expo=ps.filter(p=>p.type==="exposure"),unable=ps.filter(p=>["insufficient","insufficient_dye"].includes(p.type)),two=ps.filter(p=>p.type==="two_equally_likely"),abst=ps.filter(p=>["abstinence","non_use"].includes(p.type));
    const label=d.name||"Drug";
    const when=p=>p.period?` during ${p.period}`:"";
    const phrase=p=>`${p.frequency?`on ${p.frequency} `:""}${when(p).trim()}`.trim();
    let key="unable",line="Original assessment retained — verify classification against the detailed interpretation.";
    if(use.length){
      key="use";
      line=`was likely used ${advNaturalJoin(use.map(phrase))}`.replace(/\s+/g," ");
      if(unable.length)line+=`. However, the findings do not provide sufficient evidence to indicate use during ${advNaturalJoin(unable.map(p=>p.period||"the earlier period"))}`;
      if(abst.length)line+=`. The findings also indicate an abstinence period during ${advNaturalJoin(abst.map(p=>p.period||"the relevant period"))}`;
    }else if(expo.length){
      key="exposure";
      // Exposure category opener already records the passive-exposure opinion.
      // Keep its bullets concise: just the drug name.
      line="";
    }else if(two.length){
      key="unable";
      const alternatives=two.flatMap(p=>[
        `  ◦ Scenario 1: use of ${label.toLowerCase()}${p.frequency?` on ${p.frequency}`:""}${p.period?` during ${p.period}`:""}.`,
        `  ◦ Scenario 2: ${p.exposure_frequency||"passive exposure"} to ${label.toLowerCase()}${p.period?` during ${p.period}`:""}.`
      ]);
      line=`\n${alternatives.join("\n")}`;
    }
    else if(unable.length){key="unable";line=`Insufficient evidence to establish the most likely source during ${advNaturalJoin(unable.map(p=>p.period||"the period tested"))}`;}
    else if(abst.length){key="non_use";line=`Findings interpreted as non-use or abstinence during ${advNaturalJoin(abst.map(p=>p.period||"the relevant period"))}`;}
    if(d.summary_note)line+=`. ${d.summary_note.trim().replace(/\.$/,"")}`;
    categories[key].push(key==="exposure" ? `• ${label}` : two.length && key==="unable" ? `• ${label}: ${line.trim()}` : `• ${label} ${line.replace(/\.+$/,"")}.`);
    titles[key].push(label.toLowerCase());
  }
  const a=draft.alcohol;
  if(a?.enabled){
    let level=String(a.summary_level||"").trim();
    let period=String(a.summary_period||"").trim();
    if(!level){
      const interpretation=String(a.interpretation_text||"");
      if(/(?:not|no evidence of)\s+(?:having\s+)?consum(?:ed|ing)\s+excessive|non.excessive|low.level/i.test(interpretation))level="non-excessive consumption";
      else if(/(?:more likely than not to represent|indicate|are consistent with)\s+excessive alcohol consumption/i.test(interpretation.slice(0,700)) && !/(?:not|unlikely to|cannot|no evidence of)\s+(?:represent|indicate|suggest|be consistent with)\s+excessive alcohol consumption/i.test(interpretation.slice(0,700)))level="excessive alcohol consumption";
    }
    if(!period){
      const m=String(a.interpretation_text||"").match(/(?:period from|during the (?:majority of the )?period from)\s+(.{5,100}?)\s+(?:,|\.|including)/i);
      if(m)period=m[1].trim();
    }
    if(!level) level="[CONFIRM ALCOHOL CONSUMPTION CONCLUSION]";
    const lowLevel=/non[- ]?excessive|low[- ]?level/i.test(level);
    const alcoholClause=lowLevel ? "was likely consumed at a non-excessive, low level" : /excessive/i.test(level) ? "was likely consumed excessively" : `was likely consumed at a ${level} level`;
    const alcoholNote=String(a.summary_note||"").trim().replace(/^[,.;\s]+|[,.;\s]+$/g,"");
    const row=`• Alcohol ${alcoholClause}${period?` during ${period}`:""}${alcoholNote?`. ${alcoholNote}`:""}.`;
    categories.use.push(row);titles.use.push("alcohol");
  }
  const lines=[];
  const add=(key,heading,opening)=>{if(!categories[key].length)return;lines.push(heading,opening,...categories[key],"");};
  add("use","Substance use:",`It is my opinion that ${name} used ${advNaturalJoin(titles.use)} during the testing period.`);
  add("exposure","Substance exposure:",`It is my opinion that ${name} was unlikely to have used ${advNaturalJoin(titles.exposure)} during the testing period and was likely to have been passively exposed.`);
  add("non_use","Substance non-use / abstinence:","The following conclusions relate to the periods indicated:");
  add("unable","Unable to assess the source:","There is insufficient evidence to determine the most likely source of the following findings:");
  return lines.join("\n").trim();
}
function advUpdateDrug(drug, update) {
  const next={...drug,...update,approved:false};
  // Section decisions are optional when the expert approves the existing opinion
  // or edits the original wording. Only entering section-edit mode rebuilds periods.
  if(update.decisions) next.review_mode="sections";
  if(next.review_mode==="sections" && (update.decisions || update.form!==undefined || update.narrative_mode==="generated" || update.review_mode==="sections")) {
    next.periods=advBuildPeriods(next);
    if(next.narrative_mode!=="manual")next.interpretation_text=advBuildNarrative(next,next.periods);
  }
  if(update.review_mode==="original") {
    next.interpretation_text=next.auto_interpretation||"";
    next.periods=next.original_periods||next.periods||[];
    next.narrative_mode="manual";
  }
  return next;
}
function advSuggestion(j,decisions,form) {
  const tags=j.tags||[];
  const kinds=new Set((decisions||[]).flatMap(d=>[d.type,...(String(d.reason||"").includes("carry_over")?["carry_over"]:[]),...(String(d.reason||"").includes("exposure")?["exposure"]:[]),...(d.reason==="dye"?["dye"]:[])]));
  if(!tags.length)return "General / assess relevance";
  const match=tags.some(t=>kinds.has(t) || (t==="dye" && kinds.has("insufficient_dye")) || (t==="crack" && /crack/i.test(form||"")) || (t==="abstinence" && kinds.has("abstinence")));
  return match ? "Potentially relevant — review evidence and wording" : "Review carefully — may not match selected interpretations";
}
function advReasonSuggestions(drug) {
  const grouped=advBuildPeriodGroups(drug);
  const clinical=[];
  for(const g of grouped){
    const label=advGroupLabel(g.units);
    const period=g.period||"the represented period";
    const name=String(drug.name||"the drug").toLowerCase();
    const sectionText=label.toLowerCase().startsWith("section") ? `hair ${label.toLowerCase()}` : label.toLowerCase();
    if(g.type==="abstinence"){
      const allNd=g.units.length>0 && g.units.every(u=>u.all_nd===true);
      const wording=allNd
        ? `No ${name} or associated compounds were detected in ${sectionText} during approximately ${period}. In my opinion, these findings provide no evidence to indicate ${name} use during this period. This assessment is confined to the sections considered and should be read alongside the limitations described elsewhere in this report.`
        : `The findings from ${sectionText}, representing approximately ${period}, may be consistent with a period of abstinence from ${name}. The strength of that conclusion must be assessed against the actual detected results, the analytical limitations and any cosmetic treatments affecting these sections.`;
      clinical.push({id:`advanced_abstinence_${g.units[0]?.id}`,title:`${label} — abstinence justification${allNd?" (ND confirmed)":" (review findings)"}`,text:wording,selected:false,source:"expert draft",tags:["abstinence"]});
    }
    if(g.type==="insufficient_dye"){
      clinical.push({id:`advanced_dye_${g.units[0]?.id}`,title:`${label} — cosmetic treatment / unable to assess`,
        text:`Cosmetic hair treatment may have altered the concentrations of ${name} and its associated compounds in ${sectionText}, representing approximately ${period}. Consequently, these results do not provide sufficient evidence to determine the most likely source of the findings during this period. The significance of any earlier use, exposure and the potential value of an alternative sample require case-specific expert assessment.`,
        selected:false,source:"expert draft",tags:["dye","insufficient_dye"]});
    }
  }
  const reasons=grouped.filter(g=>g.reason).map((g,i)=>{
    const label=advGroupLabel(g.units);
    const period=g.period||"the tested period";
    const name=String(drug.name||"the drug").toLowerCase();
    let text="";
    if(g.reason==="carry_over_exposure")text=`The findings in ${label} may reflect a combination of carry-over from previous ${name} use and passive exposure during approximately ${period}. The relative contribution of either explanation must be assessed against the analytical profile, previous periods and case-specific information.`;
    else if(g.reason==="carry_over")text=`Carry-over from previously established ${name} use may contribute to the findings in ${label} during approximately ${period}. This possibility requires assessment against the earlier sections, section profile and relevant case circumstances.`;
    else if(g.reason==="passive_exposure")text=`Passive exposure to ${name} is a possible explanation for findings in ${label} during approximately ${period}. The analytical profile and case circumstances must be considered before determining whether this explanation is more likely than use.`;
    else if(g.reason==="dye")text=`The potential impact of cosmetic hair treatment on ${name} concentrations in ${label} during approximately ${period} should be considered when assessing the reliability of the interpretation.`;
    return {id:`suggested_${g.units[0]?.id}_${g.reason}`,title:`${label} — ${g.reason.replace(/_/g," ")}`,text,selected:false,source:"expert draft",tags:[g.reason]};
  }).filter(j=>j.text);
  return [...clinical,...reasons].filter((entry,index,all)=>all.findIndex(other=>other.id===entry.id)===index);
}

// Presentation-only keys: the matrix never changes the laboratory sample IDs.
const ADV_CELL_STYLES = {
  unreviewed:{label:"Unreviewed",color:"#f1f5f9",ink:"#64748b"},
  use:{label:"Use",color:"#e0525b",ink:"#fff"},
  exposure:{label:"Exposure",color:"#f6d86a",ink:"#513d10"},
  two_equally_likely:{label:"Two equally likely",color:"#f5a45d",ink:"#512b0d"},
  insufficient:{label:"Inconclusive",color:"#75abe0",ink:"#102f4d"},
  insufficient_dye:{label:"Dye / inconclusive",color:"#75abe0",ink:"#102f4d"},
  abstinence:{label:"Abstinence",color:"#8accab",ink:"#153b2e"},
  non_use:{label:"Non-use",color:"#8accab",ink:"#153b2e"}
};
const ADV_MATRIX_TYPES = ["use","exposure","two_equally_likely","insufficient","insufficient_dye","abstinence","non_use"];
function advMatrixColumn(unit) {
  const scalp=/scalp/i.test(unit.matrix||"");
  const section=/Section\s*(\d+)/i.exec(String(unit.label||""));
  // Same section across different drug rows must refer to the same parent sample.
  return scalp ? `scalp:${unit.sample_index}:${section?.[1]||unit.test_sample_index}`
    : `other:${unit.sample_index}:${unit.test_sample_index}:${unit.matrix||""}`;
}
function advMatrixColumns(drugs) {
  const map=new Map();
  (drugs||[]).forEach(drug=>(drug.units||[]).forEach(unit=>{
    const key=advMatrixColumn(unit);
    if(!map.has(key))map.set(key,{key,unit,scalp:/scalp/i.test(unit.matrix||"")});
  }));
  return [...map.values()].sort((a,b)=>{
    if(a.scalp!==b.scalp)return a.scalp?-1:1;
    if(a.unit.sample_index!==b.unit.sample_index)return Number(a.unit.sample_index)-Number(b.unit.sample_index);
    return Number(a.unit.test_sample_index)-Number(b.unit.test_sample_index);
  });
}
function advCellNumber(decision,dyed) {
  if(!decision)return "";
  if(decision.type==="use") {const i=(dyed?ADV_DYED_USE_FREQ:ADV_USE_FREQ).indexOf(decision.frequency);return i>=0?String(i+1):"✎";}
  if(decision.type==="exposure") {const i=ADV_EXPOSURE_FREQ.indexOf(decision.frequency);return i>=0?String(i+1):"✎";}
  if(decision.type==="two_equally_likely") {
    const u=(dyed?ADV_DYED_USE_FREQ:ADV_USE_FREQ).indexOf(decision.frequency);
    const e=ADV_EXPOSURE_FREQ.indexOf(decision.exposure_frequency);
    return `${u>=0?u+1:"?"}/${e>=0?e+1:"?"}`;
  }
  return "";
}

function AdvFreqSelect({value,onChange,kind,dyed=false}) {
  const options=kind==="use"?(dyed?ADV_DYED_USE_FREQ:ADV_USE_FREQ):ADV_EXPOSURE_FREQ;
  return <select style={{width:"100%",padding:10,borderRadius:9,border:"1px solid #cbd5e1"}} value={options.includes(value)?value:"__custom"} onChange={e=>onChange(e.target.value==="__custom"?"":e.target.value)}>
    <option value="__custom">{value && !options.includes(value)?`Custom: ${value}`:"Choose frequency… / enter custom"}</option>
    {options.map(v=><option key={v} value={v}>{v}</option>)}
  </select>;
}

export default function TechTeamHub() {

  const navigate = useNavigate();



  // Word report generation

  const [reportType, setReportType] = useState("normal_case");
  const [ftsMode, setFtsMode] = useState("base");
  const [outstandingAlcoholMode, setOutstandingAlcoholMode] = useState("standard");
  const [advancedDraft, setAdvancedDraft] = useState(null);
  const [advancedTab, setAdvancedTab] = useState(0);
  const [advancedPanel, setAdvancedPanel] = useState("interpretations");
  const [advancedWizardOpen, setAdvancedWizardOpen] = useState(false);
  const [advancedWizardError, setAdvancedWizardError] = useState("");
  const [matrixSelected,setMatrixSelected] = useState(null);
  const [matrixDyeStarts,setMatrixDyeStarts] = useState({});
  const [matrixAlcohol,setMatrixAlcohol] = useState({etg:"",peth:""});
  const [summaryTextOverride,setSummaryTextOverride] = useState("");
  const [summaryManual,setSummaryManual] = useState(false);
  const [summaryApproved,setSummaryApproved] = useState(false);

  const [expertName, setExpertName] = useState("");

  const [pdf, setPdf] = useState(null);

  const [caseConsiderations, setCaseConsiderations] = useState([]);

  const [interpretationJson, setInterpretationJson] = useState("");

  const [jsonStatus, setJsonStatus] = useState("");

  const [overrides, setOverrides] = useState(DEFAULT_OVERRIDES);

  const [donorInformation, setDonorInformation] = useState("");

  
  const [attoNothingDeclared, setAttoNothingDeclared] = useState(false);

const [attoCollectionDate, setAttoCollectionDate] = useState("");

  const [attoClientName, setAttoClientName] = useState("");

  const [attoInstructorName, setAttoInstructorName] = useState("");

  const [attoHairDyeDeclared, setAttoHairDyeDeclared] = useState("Declared");

  const [attoHairDyeTimingMode, setAttoHairDyeTimingMode] = useState("relative");

  const [attoHairDyeDate, setAttoHairDyeDate] = useState("");

  const [attoHairDyeRelative, setAttoHairDyeRelative] = useState("1 week prior");

  const [attoHairDyeVdl, setAttoHairDyeVdl] = useState("");

  const [attoHairDyeMultipleApplications, setAttoHairDyeMultipleApplications] = useState(false);

  const [attoCannabisUseDeclared, setAttoCannabisUseDeclared] = useState("No");
  const [attoAlcoholAbstinenceDeclared, setAttoAlcoholAbstinenceDeclared] = useState(false);

  const [attoNailAlcoholInstructed, setAttoNailAlcoholInstructed] = useState(false);
  const [attoNailDrugsInstructed, setAttoNailDrugsInstructed] = useState(false);
  const [attoNailScalpReason, setAttoNailScalpReason] = useState("");
  const [attoBodyHairAlcoholInstructed, setAttoBodyHairAlcoholInstructed] = useState(false);
  const [attoBodyHairDrugsInstructed, setAttoBodyHairDrugsInstructed] = useState(false);
  const [attoCdtInstructed, setAttoCdtInstructed] = useState(false);
  const [attoLftsInstructed, setAttoLftsInstructed] = useState(false);
  const [attoPethInstructed, setAttoPethInstructed] = useState(false);
  const [attoCdtResult, setAttoCdtResult] = useState("");
  const [attoAltResult, setAttoAltResult] = useState("");
  const [attoAstResult, setAttoAstResult] = useState("");
  const [attoGgtResult, setAttoGgtResult] = useState("");
  const [attoMcvInstructed, setAttoMcvInstructed] = useState(false);
  const [attoMcvResult, setAttoMcvResult] = useState("");
  const [attoAmphetamineOnlyInstructed, setAttoAmphetamineOnlyInstructed] = useState(false);
  const [attoCocaineNotDetected, setAttoCocaineNotDetected] = useState(false);
  const [attoEtgOnly, setAttoEtgOnly] = useState(false);

  const [busy, setBusy] = useState(false);

  const [error, setError] = useState("");



  // Blood Fix

  const [bloodReportPdf, setBloodReportPdf] = useState(null);

  const [bloodResultsPdf, setBloodResultsPdf] = useState(null);

  const [bloodTestMode, setBloodTestMode] = useState("bloods_no_mcv");

  const [bloodOutputStyle, setBloodOutputStyle] = useState("classic");

  const [bloodBusy, setBloodBusy] = useState(false);

  const [bloodError, setBloodError] = useState("");



  const isAutoreport = AUTOREPORT_TYPES.has(reportType);

  const isBloodAddendum = reportType === "outstanding_result_alcohol" && outstandingAlcoholMode === "blood";
  const requiresJson = JSON_REQUIRED_TYPES.has(reportType) || isBloodAddendum;

  const isExternalResults = reportType === "external_results";



  const attoCannabisTested = useMemo(() => {

    if (reportType !== "atto" || !interpretationJson.trim()) {

      return false;

    }



    try {

      return attoJsonHasCannabisTesting(JSON.parse(interpretationJson));

    } catch {

      return false;

    }

  }, [reportType, interpretationJson]);

  const attoTestingProfile = useMemo(() => {
    if (reportType !== "atto" || !interpretationJson.trim()) {
      return attoJsonTestingProfile(null);
    }
    try {
      return attoJsonTestingProfile(JSON.parse(interpretationJson));
    } catch {
      return attoJsonTestingProfile(null);
    }
  }, [reportType, interpretationJson]);





  const selectedReportLabel = useMemo(() => {

    return REPORT_TYPES.find((r) => r.key === reportType)?.label || "Report";

  }, [reportType]);



  function editAdvancedDrug(index, update) {
    setSummaryApproved(false);
    setAdvancedDraft(prev => ({...prev, drugs: prev.drugs.map((d,i)=>i===index?advUpdateDrug(d,update):d)}));
  }

  function editAdvancedAlcohol(update) {
    setSummaryApproved(false);
    // Only content edits invalidate approval; confirmation must retain approved=true.
    setAdvancedDraft(prev => ({...prev,alcohol:{...prev.alcohol,...update,approved:false}}));
  }
  function confirmAdvancedAlcohol() {
    setAdvancedDraft(prev => ({...prev,alcohol:{...prev.alcohol,approved:true}}));
  }

  // Wizard steps: one review task visible at a time, with explicit validation.
  const wizardItems = advancedDraft ? [
    ...(advancedDraft.drugs||[]).map((d,i)=>({id:i,label:d.name,approved:!!d.approved && !wizardValidateDrugSections(d)})),
    ...(advancedDraft.alcohol?.enabled ? [{id:-1,label:"Alcohol",approved:!!advancedDraft.alcohol.approved}] : []),
  ] : [];
  const wizardIndex = wizardItems.findIndex(item=>item.id===advancedTab);
  const matrixColumns = advancedDraft ? advMatrixColumns(advancedDraft.drugs) : [];
  const matrixDrugTotal=(advancedDraft?.drugs||[]).reduce((n,d)=>n+(d.units||[]).length,0);
  const matrixReviewed=(advancedDraft?.drugs||[]).reduce((n,d)=>n+(d.units||[]).filter(u=>(d.decisions||[]).some(x=>x.id===u.id&&x.type!=="unreviewed")).length,0);
  const matrixDone=matrixDrugTotal===matrixReviewed && (advancedDraft?.drugs||[]).every(d=>d.review_mode!=="sections" || !wizardValidateDrugSections(d));
  const wizardStages = ["interpretations","justifications","consistency"];
  const wizardStageIndex = wizardStages.indexOf(advancedPanel);
  const wizardFinished = advancedTab===-2;
  const wizardComplete = wizardItems.every(item=>item.approved);
  const generatedSummaryText = advBuildFinalSummary(advancedDraft);
  const finalSummaryText = summaryManual ? summaryTextOverride : generatedSummaryText;
  const wizardSummaryReady = wizardComplete && summaryApproved && !!finalSummaryText.trim() && !finalSummaryText.includes("[CONFIRM ");

  function matrixIsDyed(unit) {
    if(!caseConsiderations.includes("Hair Dye")||!/scalp/i.test(unit?.matrix||""))return false;
    const index=Number(unit.sample_index);
    const first=matrixDyeStarts[index];
    if(!first)return false;
    const n=Number(/Section\s*(\d+)/i.exec(String(unit.label||""))?.[1]||Number(unit.test_sample_index)+1);
    return n>=Number(first);
  }
  function matrixSetDecision(drugIndex,unit,change) {
    setSummaryApproved(false);
    setAdvancedDraft(prev=>({...prev,drugs:prev.drugs.map((drug,i)=>{
      if(i!==drugIndex)return drug;
      const before=(drug.decisions||[]).find(d=>d.id===unit.id)||{id:unit.id};
      const next={...before,...change,group_previous:false};
      // Explicitly choosing a conclusion resets obsolete frequencies; no unapproved
      // automatic narrative is retained when a cell enters section-edit mode.
      if(change.type && change.type!==before.type){
        next.frequency="";next.exposure_frequency="";
        if(change.type==="use" || change.type==="two_equally_likely")next.frequency=(matrixIsDyed(unit)?ADV_DYED_USE_FREQ:ADV_USE_FREQ)[0];
        if(change.type==="exposure")next.frequency=ADV_EXPOSURE_FREQ[0];
        if(change.type==="two_equally_likely")next.exposure_frequency=ADV_EXPOSURE_FREQ[0];
      }
      const updated=(drug.decisions||[]).map(d=>d.id===unit.id?next:d);
      // Automatically combine adjacent matching scalp sections without ever
      // removing individual underlying sample decisions.
      const decisions=updated.map((d,j)=>{
        const previous=updated[j-1];
        return {...d,group_previous:j>0&&advCanGroupUnits(drug.units?.[j-1],drug.units?.[j])&&advSameDecision(previous,d)};
      });
      return advUpdateDrug(drug,{decisions,review_mode:"sections",narrative_mode:"generated"});
    })}));
  }
  function matrixValidate() {
    for(const d of advancedDraft?.drugs||[]){
      if(d.review_mode!=="sections")continue;
      const problem=wizardValidateDrugSections(d);
      if(problem)return `${d.name}: ${problem}`;
      for(const u of d.units||[]){
        const dec=(d.decisions||[]).find(x=>x.id===u.id);
        if(["abstinence","non_use"].includes(dec?.type)&&u.all_nd===false&&!String(dec?.reason||"").trim())
          return `${d.name} — ${u.label}: detected analytical findings with a green conclusion require an explanation.`;
      }
    }
    return "";
  }
  function wizardGo(tab, panel="interpretations") {
    setAdvancedWizardError("");
    setAdvancedTab(tab);
    setAdvancedPanel(panel);
    const body=document.getElementById("fts-advanced-wizard-scroll");
    if(body)body.scrollTop=0;
  }

  // The backend requires an explicit conclusion for every *actual* test section.
  // Grouping changes presentation, but never removes a section from review.
  function wizardValidateDrugSections(subject) {
    // Existing report conclusions and free-text revisions do NOT require
    // artificial section decisions. The original periods remain authoritative.
    if (["original","manual"].includes(subject.review_mode)) return "";
    const units=subject.units||[];
    const decisions=subject.decisions||[];
    if (!units.length) return ""; // No section matrix available: retain manual expert review.
    const actual=new Set(units.map(u=>u.id));
    if (decisions.length!==units.length ||
        new Set(decisions.map(d=>d.id)).size!==units.length ||
        decisions.some(d=>!actual.has(d.id))) {
      return "Section decisions are incomplete or no longer match the test samples. Re-run the Advanced preview.";
    }
    const validTypes=new Set(ADV_TYPES.map(([key])=>key).filter(key=>key!=="unreviewed"));
    const groups=advBuildPeriodGroups(subject);
    for (const unit of units) {
      const d=decisions.find(x=>x.id===unit.id);
      if(unit.all_nd===false && ["abstinence","non_use"].includes(d?.type) && !String(d?.reason||"").trim())
        return `${unit.label}: a green conclusion with detected results requires an explanation.`;
    }
    for (const group of groups) {
      const label=advGroupLabel(group.units);
      if (!validTypes.has(group.type))
        return `${label}: select an expert interpretation before continuing.`;
      if (["use","exposure","two_equally_likely"].includes(group.type) && !String(group.frequency||"").trim())
        return `${label}: choose a ${group.type==="exposure"?"passive-exposure":"use"} frequency.`;
      if (group.type==="two_equally_likely" && !String(group.exposure_frequency||"").trim())
        return `${label}: choose the alternative exposure frequency.`;
    }
    return "";
  }

  function wizardValidateStage() {
    if(!advancedDraft)return "No advanced preview is loaded.";
    if(advancedTab===-3)return matrixValidate();
    const subject=advancedTab===-1?advancedDraft.alcohol:advancedDraft.drugs?.[advancedTab];
    if(!subject)return "No subject selected.";
    // Check on EVERY stage: a section must never become approved just because
    // the user reached Consistency using old/stale selections.
    if (advancedTab>=0) {
      const problem=wizardValidateDrugSections(subject);
      if (problem) return problem;
    }
    if(advancedPanel==="interpretations" && !String(subject.interpretation_text||"").trim())
      return "Review or enter the final interpretation before continuing.";
    if(advancedPanel==="justifications" &&
        (subject.justifications||[]).some(j=>j.selected&&!String(j.text||"").trim()))
      return "A selected justification has no wording. Edit or deselect it before continuing.";
    return "";
  }

  function wizardNext() {
    const err=wizardValidateStage();
    if(err){setAdvancedWizardError(err);return;}
    setAdvancedWizardError("");
    if(advancedTab===-3){wizardGo(wizardItems[0]?.id??-2,"interpretations");return;}
    if(advancedPanel!=="consistency"){
      wizardGo(advancedTab,wizardStages[wizardStageIndex+1]);
      return;
    }
    // Completing consistency is the only place approval is granted.
    if(advancedTab===-1)confirmAdvancedAlcohol();
    else setAdvancedDraft(prev=>({...prev,drugs:prev.drugs.map((d,i)=>i===advancedTab?{...d,approved:true}:d)}));
    if(wizardIndex+1<wizardItems.length)wizardGo(wizardItems[wizardIndex+1].id);
    else wizardGo(-2);
  }
  function wizardBack() {
    if(wizardFinished){
      const last=wizardItems[wizardItems.length-1];
      if(last)wizardGo(last.id,"consistency");
    }else if(advancedTab===-3)return;
    else if(wizardStageIndex>0)wizardGo(advancedTab,wizardStages[wizardStageIndex-1]);
    else if(wizardIndex>0)wizardGo(wizardItems[wizardIndex-1].id,"consistency");
    else wizardGo(-3);
  }

  function toggleInfluence(name) {

    setCaseConsiderations((prev) =>

      prev.includes(name)

        ? prev.filter((x) => x !== name)

        : [...prev, name]

    );

  }



  function updateOverride(key, value) {

    setOverrides((prev) => ({

      ...prev,

      [key]: value,

    }));

  }



  function toggleStoredSample(name) {

    setOverrides((prev) => ({

      ...prev,

      samples_stored: prev.samples_stored.includes(name)

        ? prev.samples_stored.filter((item) => item !== name)

        : [...prev.samples_stored, name],

    }));

  }



  function syncOverridesFromJson(data) {

    const declarations =

      data?.declarations && typeof data.declarations === "object"

        ? data.declarations

        : {};



    const additional =

      data?.additional_case_information &&

      typeof data.additional_case_information === "object"

        ? data.additional_case_information

        : {};



    setDonorInformation(

      String(

        data?.donor_information ??

          additional.donor_information ??

          ""

      )

    );



    

  setAttoNothingDeclared(
    ["yes", "true", "1", "checked"].includes(
      String(
        data?.atto_nothing_declared ??
          additional.atto_nothing_declared ??
          "No"
      ).toLowerCase()
    )
  );

setAttoClientName(String(data?.atto_client_name_override ?? data?.client_name ?? ""));

    setAttoInstructorName(String(data?.atto_instructor_override ?? ""));



    const dyePresent = String(data?.atto_hair_dye_present ?? "").toLowerCase() === "yes";

    setCaseConsiderations((prev) => {

      const withoutHairDye = prev.filter((item) => item !== "Hair Dye");

      return dyePresent ? [...withoutHairDye, "Hair Dye"] : withoutHairDye;

    });

    setAttoHairDyeDeclared(

      String(data?.atto_hair_dye_declared ?? "Declared") || "Declared"

    );

    setAttoHairDyeTimingMode(

      String(data?.atto_hair_dye_timing_mode ?? "relative") || "relative"

    );

    setAttoHairDyeDate(String(data?.atto_hair_dye_date ?? ""));

    setAttoHairDyeRelative(

      String(data?.atto_hair_dye_timing ?? "1 week prior") || "1 week prior"

    );

    setAttoHairDyeVdl(String(data?.atto_hair_dye_vdl_location ?? ""));

    setAttoHairDyeMultipleApplications(

      ["yes", "true", "1"].includes(

        String(data?.atto_hair_dye_multiple_applications ?? "No").toLowerCase()

      )

    );

    const yesFlag = (value) =>
      ["yes", "true", "1", "checked"].includes(String(value ?? "").toLowerCase());

    setAttoNailAlcoholInstructed(yesFlag(data?.Nail_Alcohol_Instructed));
    setAttoNailDrugsInstructed(yesFlag(data?.Nail_Drugs_Instructed));
    setAttoNailScalpReason(String(data?.Atto_Nail_Scalp_Reason ?? ""));
    setAttoBodyHairAlcoholInstructed(yesFlag(data?.BodyHair_Alcohol_Instructed));
    setAttoBodyHairDrugsInstructed(yesFlag(data?.BodyHair_Drugs_Instructed));
    const testingProfile = attoJsonTestingProfile(data);

    setAttoCdtInstructed(testingProfile.cdtPresent || yesFlag(data?.CDT_Instructed));
    setAttoLftsInstructed(testingProfile.lftsPresent || yesFlag(data?.LFTs_Instructed));
    setAttoMcvInstructed(testingProfile.mcvPresent || yesFlag(data?.MCV_Instructed));
    setAttoPethInstructed(testingProfile.pethPresent || yesFlag(data?.PEth_Instructed));
    setAttoCdtResult(String(data?.Atto_CDT_Result ?? ""));
    setAttoAltResult(String(data?.Atto_ALT_Result ?? ""));
    setAttoAstResult(String(data?.Atto_AST_Result ?? ""));
    setAttoGgtResult(String(data?.Atto_GGT_Result ?? ""));
    setAttoMcvResult(String(data?.Atto_MCV_Result ?? ""));
    setAttoAmphetamineOnlyInstructed(yesFlag(data?.Amphetamine_Only_Instructed));
    setAttoCocaineNotDetected(yesFlag(data?.Cocaine_Not_Detected));
    setAttoEtgOnly(yesFlag(data?.Atto_EtG_Only));
    setAttoAlcoholAbstinenceDeclared(yesFlag(data?.Atto_Alcohol_Abstinence_Declared));



    setOverrides({

      samples_stored: Array.isArray(additional.samples_stored)

        ? additional.samples_stored

        : [],

      blood_selection: matchOption(

        additional.blood_tests_instructed,

        BLOOD_OPTIONS,

        "None"

      ),

      peth_instructed: ["yes", "true", "1"].includes(

        String(additional.peth_instructed ?? "No").toLowerCase()

      )

        ? "Yes"

        : "No",

      cannabis_use: matchOption(

        declarations.cannabis_use,

        CANNABIS_OPTIONS,

        "No"

      ),

      previous_doa: matchOption(

        declarations.previous_doa_results,

        PREVIOUS_DOA_OPTIONS,

        "No"

      ),

      thermal_straightening: matchOption(

        declarations.thermal_hair_straightening,

        THERMAL_OPTIONS,

        "Unknown"

      ),

      linked_case: matchOption(

        declarations.linked_case,

        LINKED_CASE_OPTIONS,

        "No"

      ),

      alcohol_usage: matchOption(

        declarations.alcohol_level,

        ALCOHOL_OPTIONS,

        "Low"

      ),

      previous_scalp_site: matchOption(

        additional.previous_scalp_sample_site,

        PREVIOUS_SCALP_SITE_OPTIONS,

        "No"

      ),

      previous_site_growth: matchOption(

        additional.previous_site_growth_rate,

        PREVIOUS_SITE_GROWTH_OPTIONS,

        "Average"

      ),

      medications: matchOption(

        additional.medications,

        MEDICATION_OPTIONS,

        "None"

      ),

    });

  }



  function validateJson(showSuccess = true) {

    try {

      const parsed = JSON.parse(interpretationJson);



      if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {

        throw new Error(

          "The top level of the interpretation JSON must be an object."

        );

      }



      if (parsed.samples !== undefined && !Array.isArray(parsed.samples)) {

        throw new Error("The JSON field 'samples' must be a list.");

      }



      // Validation must NOT re-import original JSON overrides. The donor's
      // initially supplied values are loaded in handleJsonFile(); subsequent
      // UI selections (including medication and daily cannabis use) remain
      // authoritative until a different file is explicitly uploaded.

      const sampleCount = Array.isArray(parsed.samples)

        ? parsed.samples.length

        : 0;



      setJsonStatus(`JSON valid - ${sampleCount} sample(s) found.`);

      setError("");



      if (showSuccess) {

        return parsed;

      }



      return parsed;

    } catch (err) {

      setJsonStatus("");

      setError(`Invalid interpretation JSON: ${err.message}`);

      return null;

    }

  }



  async function handleJsonFile(event) {

    const file = event.target.files?.[0];



    if (!file) {

      return;

    }



    try {

      const text = await file.text();

      setInterpretationJson(text);



      const parsed = JSON.parse(text);

      syncOverridesFromJson(parsed);



      const sampleCount = Array.isArray(parsed.samples)

        ? parsed.samples.length

        : 0;



      setJsonStatus(

        `Loaded ${file.name} - ${sampleCount} sample(s) found.`

      );

      setError("");

    } catch (err) {

      setJsonStatus("");

      setError(`Could not load JSON: ${err.message}`);

    }

  }



  async function handleGenerate() {

    setError("");



    if (!reportType) {

      setError("Please select a report type.");

      return;

    }



    if (!expertName) {

      setError("Please select your name.");

      return;

    }



    if (!pdf) {

      setError("Please upload the existing report PDF.");

      return;

    }



    if (requiresJson && !interpretationJson.trim()) {

      setError(

        isExternalResults

          ? "Please paste or upload the analytical JSON for this External Results report. It is required to verify the complete result table."

          : "Please paste or upload the interpretation JSON for this report type."

      );

      return;

    }



    const parsedJson = requiresJson ? validateJson(false) : null;



    if (requiresJson && !parsedJson) {

      return;

    }



    if (reportType === "atto" && !attoCollectionDate) {

      setError("Please enter the correct Atto collection date.");

      return;

    }



    if (reportType === "atto" && !attoClientName.trim()) {

      setError("Please enter the client's full name, including title (for example: Ms Jane Smith).");

      return;

    }



    const attoHairDyePresent =

      reportType === "atto" && caseConsiderations.includes("Hair Dye");



    let attoVdlValue = "";

    if (attoHairDyePresent && attoHairDyeVdl !== "") {

      const vdlNumber = Number(attoHairDyeVdl);

      if (Number.isNaN(vdlNumber) || vdlNumber < 0 || vdlNumber > 12) {

        setError("Please enter a VDL location between 0 and 12 cm.");

        return;

      }

      attoVdlValue = String(vdlNumber);

    }



    const finalOverrides = reportType === "atto"

      ? {

          donor_information: donorInformation.trim(),

           atto_nothing_declared: attoNothingDeclared,

          collection_date_override: attoCollectionDate,

          atto_client_name_override: attoClientName.trim(),

          atto_instructor_override: attoInstructorName.trim(),

          atto_instructor_from_override: "",

          atto_hair_dye_present: attoHairDyePresent ? "Yes" : "No",

          atto_hair_dye_declared: attoHairDyePresent ? attoHairDyeDeclared : "",

          atto_hair_dye_timing_mode: attoHairDyePresent ? attoHairDyeTimingMode : "",

          atto_hair_dye_date:

            attoHairDyePresent && attoHairDyeTimingMode === "date"

              ? attoHairDyeDate

              : "",

          atto_hair_dye_timing:

            attoHairDyePresent && attoHairDyeTimingMode === "relative"

              ? attoHairDyeRelative

              : "",

          atto_hair_dye_vdl_location: attoHairDyePresent ? attoVdlValue : "",

          atto_hair_dye_multiple_applications:

            attoHairDyePresent && attoHairDyeMultipleApplications ? "Yes" : "No",

          atto_cannabis_use_declared: attoCannabisTested ? attoCannabisUseDeclared : "No",
           Atto_Alcohol_Abstinence_Declared: attoTestingProfile.alcohol && attoAlcoholAbstinenceDeclared ? "Yes" : "No",

          Nail_Alcohol_Instructed: attoNailAlcoholInstructed ? "Yes" : "No",
          Nail_Drugs_Instructed: attoNailDrugsInstructed ? "Yes" : "No",
           Atto_Nail_Scalp_Reason: (attoTestingProfile.nailAlcohol || attoTestingProfile.nailDrugs) && !attoNailAlcoholInstructed && !attoNailDrugsInstructed ? attoNailScalpReason : "",
          BodyHair_Alcohol_Instructed: attoBodyHairAlcoholInstructed ? "Yes" : "No",
          BodyHair_Drugs_Instructed: attoBodyHairDrugsInstructed ? "Yes" : "No",
          CDT_Instructed: (attoTestingProfile.cdtPresent || attoCdtInstructed) ? "Yes" : "No",
          LFTs_Instructed: (attoTestingProfile.lftsPresent || attoLftsInstructed) ? "Yes" : "No",
          MCV_Instructed: (attoTestingProfile.mcvPresent || attoMcvInstructed) ? "Yes" : "No",
          PEth_Instructed: (attoTestingProfile.pethPresent || attoPethInstructed) ? "Yes" : "No",
          Atto_CDT_Result: (!attoTestingProfile.cdtPresent && attoCdtInstructed) ? attoCdtResult.trim() : "",
          Atto_ALT_Result: (!attoTestingProfile.lftsPresent && attoLftsInstructed) ? attoAltResult.trim() : "",
          Atto_AST_Result: (!attoTestingProfile.lftsPresent && attoLftsInstructed) ? attoAstResult.trim() : "",
          Atto_GGT_Result: (!attoTestingProfile.lftsPresent && attoLftsInstructed) ? attoGgtResult.trim() : "",
          Atto_MCV_Result: (!attoTestingProfile.mcvPresent && attoMcvInstructed) ? attoMcvResult.trim() : "",
          Amphetamine_Only_Instructed: attoAmphetamineOnlyInstructed ? "Yes" : "No",
           Cocaine_Not_Detected: attoCocaineNotDetected ? "Yes" : "No",
           Atto_EtG_Only: attoEtgOnly ? "Yes" : "No",

        }

      : {

          ...overrides,

          previous_site_growth:

            overrides.previous_scalp_site === "No"

              ? ""

              : overrides.previous_site_growth,

        };



    let finalInterpretationJson = interpretationJson;



    if (reportType === "atto" && parsedJson) {

      finalInterpretationJson = JSON.stringify(

        {

          ...parsedJson,

          donor_information: donorInformation.trim(),

          ...finalOverrides,

        },

        null,

        2

      );

    }



    try {

      setBusy(true);



      const safeBase = pdf.name.replace(/\.pdf$/i, "") || "report";



      const downloadBlob = (blob, filename) => {

        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");



        a.href = url;

        a.download = filename;



        document.body.appendChild(a);

        a.click();

        a.remove();



        window.setTimeout(() => {

          window.URL.revokeObjectURL(url);

        }, 1000);

      };



      // Advanced beta: use a separate review/generation API.
      if (reportType === "normal_case" && ftsMode === "advanced") {
        const payload = {pdf, expertName, caseConsiderations,
          interpretationJson: finalInterpretationJson, overrideValues: finalOverrides};
        if (!advancedDraft) {
          const preview = await advancedTechTeamReport(payload);
          // Every drug starts with the baseline FTS interpretation unchanged.
          // Only the explicit section-edit path triggers per-section validation.
          preview.drugs=(preview.drugs||[]).map(d=>({...d,review_mode:"original",original_periods:d.periods||[],narrative_mode:"manual"}));
          setAdvancedDraft(preview);
          setSummaryManual(false);setSummaryTextOverride("");setSummaryApproved(false);
          setAdvancedTab(preview.drugs?.length ? 0 : (preview.alcohol?.enabled ? -1 : -2));
          setAdvancedPanel("interpretations");
          setAdvancedWizardError("");
          setAdvancedWizardOpen(true);
        } else {
          const approval = {source_hash:advancedDraft.source_hash,drugs: advancedDraft.drugs, alcohol: advancedDraft.alcohol,
            summary:{approved:wizardSummaryReady,text:finalSummaryText}};
          // The final review must match backend section-coverage validation.
          // In particular, approved=true is not proof that a grouped section has
          // been assigned a conclusion; older drafts could incorrectly be approved.
          for (let i=0;i<approval.drugs.length;i++) {
            const problem=wizardValidateDrugSections(approval.drugs[i]);
            if (problem) {
              setAdvancedTab(i);
              setAdvancedPanel("interpretations");
              setAdvancedWizardOpen(true);
              setAdvancedWizardError(problem);
              throw new Error(`${approval.drugs[i].name}: ${problem}`);
            }
          }
          if (approval.drugs.some(d=>!d.approved)) {
            throw new Error("Confirm every detected drug interpretation before generating Advanced mode.");
          }
          if (approval.alcohol?.enabled && !approval.alcohol.approved) {
            throw new Error("Confirm the Alcohol tab before generating the Advanced report.");
          }
          const blob = await advancedTechTeamReport({...payload,approval});
          downloadBlob(blob,`${safeBase}_advanced_BETA.docx`);
        }
        return;
      }

      // ------------------------------------------------------

      // Primary requested report

      // ------------------------------------------------------

      const blob = await generateTechTeamReport({

        pdf,

        reportType: isBloodAddendum ? "outstanding_result_vbloods" : reportType,

        expertName,

        caseConsiderations:

          reportType === "atto"

            ? (caseConsiderations.includes("Hair Dye") ? ["Hair Dye"] : [])

            : caseConsiderations,

        interpretationJson: requiresJson ? finalInterpretationJson : "",

        // External Results uses JSON only as authoritative analytical source

        // data. Do not apply normal autoreport declaration overrides.

        overrideValues: isAutoreport

          ? finalOverrides

          : {},

      });



      downloadBlob(

        blob,

        requiresJson

          ? `${safeBase}_completed.docx`

          : `${safeBase}_populated.docx`

      );



      // ------------------------------------------------------

      // Atto also produces the existing External Results

      // certificate of analysis from the ORIGINAL PDF + JSON.

      // No Atto webpage overrides are passed to this second run.

      // ------------------------------------------------------

      if (reportType === "atto") {

        const externalResultsBlob = await generateTechTeamReport({

          pdf,

          reportType: "external_results",

          expertName,

          caseConsiderations: [],

          interpretationJson,

          overrideValues: {},

        });



        downloadBlob(

          externalResultsBlob,

          `${safeBase}_external_results.docx`

        );

      }

    } catch (err) {

      setError(err?.message || "Report generation failed.");

    } finally {

      setBusy(false);

    }

  }



  async function handleBloodFixGenerate() {

    setBloodError("");



    if (bloodOutputStyle === "classic" && !bloodReportPdf) {

      setBloodError(

        "Please upload the main report PDF for Classic style."

      );

      return;

    }



    if (!bloodResultsPdf) {

      setBloodError("Please upload the blood results PDF.");

      return;

    }



    try {

      setBloodBusy(true);



      const blob = await generateBloodFixPdf({

        reportPdf: bloodReportPdf,

        bloodPdf: bloodResultsPdf,

        bloodTestMode,

        outputStyle: bloodOutputStyle,

      });



      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");



      const sourceFile =

        bloodOutputStyle === "new_report"

          ? bloodResultsPdf

          : bloodReportPdf;



      const safeBase =

        sourceFile?.name?.replace(/\.pdf$/i, "") ||

        "blood_results";



      a.href = url;

      a.download =

        bloodOutputStyle === "new_report"

          ? `${safeBase}_blood_results.docx`

          : `${safeBase}_with_blood_summary.pdf`;

      document.body.appendChild(a);

      a.click();



      a.remove();

      window.URL.revokeObjectURL(url);

    } catch (err) {

      setBloodError(err?.message || "Blood Fix failed.");

    } finally {

      setBloodBusy(false);

    }

  }



  return (

    <div style={styles.page} className="tech-team-page">

      <style>{`

        .tech-team-page \* { box-sizing: border-box; }

        .tech-team-page button,

        .tech-team-page input,

        .tech-team-page select,

        .tech-team-page textarea {

          transition: border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease, background 160ms ease;

        }

        .tech-team-page input:not([type="checkbox"]):focus,

        .tech-team-page select:focus,

        .tech-team-page textarea:focus {

          outline: none;

          border-color: #00528c !important;

          box-shadow: 0 0 0 4px rgba(0, 82, 140, 0.10), 0 4px 16px rgba(15, 23, 42, 0.06) !important;

        }

        .tech-team-page input[readonly] {

          color: #475569;

          background: #f8fafc !important;

        }

        .tech-report-button:hover {

          transform: translateY(-3px);

          box-shadow: 0 10px 24px rgba(15, 23, 42, 0.12);

          border-color: #00528c !important;

        }

        .tech-report-button.active:hover {

          border-color: #c91c1c !important;

          box-shadow: 0 12px 28px rgba(201, 28, 28, 0.23);

        }

        .tech-action-button:hover:not(:disabled),

        .tech-secondary-button:hover,

        .tech-back-button:hover {

          transform: translateY(-2px);

          box-shadow: 0 9px 20px rgba(15, 23, 42, 0.13);

        }

        .tech-action-button:active:not(:disabled),

        .tech-secondary-button:active,

        .tech-back-button:active,

        .tech-report-button:active {

          transform: translateY(0);

        }

        .tech-card {

          position: relative;

          overflow: hidden;

        }

        .tech-card::before {

          content: "";

          position: absolute;

          inset: 0 auto 0 0;

          width: 4px;

          background: linear-gradient(180deg, #00528c 0%, #7B3759 55%, #c91c1c 100%);

          opacity: 0.9;

        }

        .tech-nested-panel {

          position: relative;

          overflow: hidden;

        }

        .tech-nested-panel::after {

          content: "";

          position: absolute;

          top: 0; left: 0; right: 0;

          height: 3px;

          background: linear-gradient(90deg, #00528c, #7B3759, #c91c1c);

          opacity: 0.7;

        }

        .tech-team-page input[type="checkbox"] {

          accent-color: #7B3759;

          width: 17px;

          height: 17px;

        }

        .tech-team-page input[type="file"]::file-selector-button {

          border: 0;

          border-radius: 9px;

          padding: 8px 12px;

          margin-right: 12px;

          background: #00528c;

          color: white;

          font-weight: 800;

          cursor: pointer;

        }


        .adv-matrix-board{color:#1c3045;font-family:inherit;}
        .adv-matrix-header{display:flex;justify-content:space-between;gap:22px;align-items:center;padding:18px 4px 20px;}
        .adv-matrix-header h2{font-size:28px;letter-spacing:-.04em;color:#103f63;margin:3px 0 7px;}
        .adv-matrix-header p,.adv-matrix-bottom p{color:#718195;font-size:13px;line-height:1.55;max-width:760px;margin:0;}
        .adv-eyebrow{font-size:10px;letter-spacing:.17em;color:#7b3759;font-weight:850;}
        .adv-progress{padding:13px 20px;border-radius:18px;background:linear-gradient(140deg,#eff6fc,#f8f3f7);border:1px solid #d8e7f2;text-align:center;white-space:nowrap;}
        .adv-progress strong{display:block;font-size:23px;color:#00528c;}.adv-progress span{font-size:11px;color:#687b8b;font-weight:700;}
        .adv-legend{display:flex;flex-wrap:wrap;gap:9px 17px;padding:12px 15px;margin-bottom:16px;background:#f7f9fc;border:1px solid #e4eaf1;border-radius:14px;}
        .adv-legend span{display:flex;gap:7px;align-items:center;font-size:12px;font-weight:700;}.adv-legend i{width:14px;height:14px;border-radius:5px;display:inline-block;}
        .adv-dye-control{padding:14px 17px;margin:0 0 16px;border-radius:16px;background:#fff9ee;border:1px solid #efd9ac;}
        .adv-dye-control strong{color:#754b15;}.adv-dye-control p{margin:5px 0 10px;font-size:12px;color:#866c4d;}.adv-dye-control label{display:inline-flex;align-items:center;gap:10px;margin:0 15px 5px 0;font-weight:700;font-size:12px;}
        .adv-dye-control select,.adv-fields select,.adv-fields input,.adv-reason textarea,.adv-alcohol-tile select{border:1px solid #cbd8e5;border-radius:10px;padding:9px 11px;background:white;font:inherit;color:#243a50;}
        .adv-matrix-scroll{overflow:auto;border-radius:16px;border:1px solid #dbe5ee;background:#fff;max-height:400px;}
        .adv-matrix-table{border-spacing:0;border-collapse:separate;min-width:100%;font-size:13px;}
        .adv-matrix-table th,.adv-matrix-table td{padding:9px 11px;border-right:1px solid #e8eef4;border-bottom:1px solid #e8eef4;text-align:center;min-width:116px;}
        .adv-matrix-table thead th{position:sticky;top:0;z-index:2;background:#f2f6fa;color:#1d4465;font-size:12px;white-space:nowrap;}
        .adv-matrix-table thead small,.adv-matrix-table tbody th small{display:block;color:#8090a1;font-size:10px;font-weight:550;margin-top:3px;}
        .adv-matrix-table .adv-sticky-name{position:sticky;left:0;min-width:175px;z-index:3;text-align:left;background:#f8fafc;font-weight:800;}
        .adv-matrix-table thead .adv-sticky-name{z-index:4;background:#eaf1f7;}
        .adv-matrix-table .adv-dye-start{border-left:3px dashed #b98b4d!important;}
        .adv-matrix-cell{border:2px solid transparent;border-radius:12px;min-width:77px;min-height:47px;width:100%;font-size:17px;font-weight:850;cursor:pointer;position:relative;box-shadow:inset 0 -2px rgba(0,0,0,.055);}
        .adv-matrix-cell.selected{border-color:#00528c;outline:3px solid #bed8ee;transform:scale(1.02);}
        .adv-matrix-cell em{position:absolute;right:4px;top:2px;background:#fff;color:#ae321c;border-radius:50%;font-style:normal;font-size:10px;width:16px;height:16px;}
        .adv-matrix-absent{color:#b2bfcd;}.adv-empty{padding:20px;border-radius:13px;background:#f4f8fc;}
        .adv-cell-editor{margin-top:18px;border:1px solid #cbdce9;background:linear-gradient(#fbfdff,#f4f8fb);border-radius:18px;padding:20px;box-shadow:0 9px 25px rgba(28,60,83,.07);}
        .adv-editor-top{display:flex;align-items:start;justify-content:space-between;gap:14px;}.adv-editor-top h3{color:#00528c;margin:5px 0;font-size:20px;}.adv-editor-top h3 span{font-weight:500;color:#677c90;}.adv-editor-top p{margin:0 0 13px;font-size:12px;color:#697c8c;}
        .adv-editor-close{border:0;background:#edf3f8;border-radius:10px;padding:8px 12px;color:#526a80;cursor:pointer;}
        .adv-choice-grid{display:flex;flex-wrap:wrap;gap:8px;margin-bottom:14px;}.adv-choice{display:flex;gap:7px;align-items:center;border:1px solid #d5e0ea;background:white;color:#30495c;border-radius:12px;padding:9px 11px;font-size:12px;font-weight:750;cursor:pointer;}.adv-choice.active{border:2px solid #00528c;background:#edf5fb;}.adv-choice-dot{height:14px;width:14px;border-radius:5px;background:var(--choice);}
        .adv-fields{display:grid;grid-template-columns:repeat(auto-fit,minmax(190px,1fr));gap:12px;margin:14px 0;}.adv-fields label,.adv-reason{display:flex;flex-direction:column;gap:6px;font-size:12px;}.adv-fields select,.adv-fields input{width:100%;}.adv-reason textarea{width:100%;resize:vertical;}
        .adv-warning{color:#904d19;background:#fff5e6;padding:10px;border-radius:9px;border:1px solid #f0d3a8;font-size:12px;}.adv-note{font-size:12px;color:#678094;line-height:1.5;}
        .adv-matrix-bottom{display:flex;align-items:center;justify-content:space-between;gap:20px;margin-top:20px;border-top:1px solid #e2eaf1;padding:20px 4px;}.adv-matrix-bottom strong{color:#00528c;}
        .adv-alcohol-board{padding:17px;margin-bottom:18px;border:1px solid #d6e2ed;border-radius:16px;background:#f6f9fc;}.adv-alcohol-board p{color:#6e7e8d;font-size:12px;line-height:1.55;}
        .adv-alcohol-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(210px,1fr));gap:13px;}.adv-alcohol-tile{display:flex;flex-direction:column;gap:7px;border:1px solid #dce6f0;background:white;border-radius:13px;padding:13px;}.adv-alcohol-tile strong{font-size:17px;color:#00528c;}.adv-alcohol-tile small{color:#8594a3;}
        @media(max-width:650px){.adv-matrix-header,.adv-matrix-bottom{align-items:stretch;flex-direction:column;}.adv-progress{align-self:flex-start;}.adv-cell-editor{padding:12px;}.adv-matrix-table .adv-sticky-name{min-width:130px;}}

        @media (max-width: 720px) {

          .tech-team-page { padding: 14px !important; }

          .tech-hero { padding: 22px !important; }

          .tech-card { padding: 20px !important; }

        }

      `}</style>

      <div style={styles.shell} className="tech-shell">

        <div style={styles.topBar}>

          <button className="tech-back-button" style={styles.backBtn} onClick={() => navigate("/")}>

            ← Back

          </button>

        </div>



        <div style={styles.hero} className="tech-hero">

          <div style={styles.heroAccent}>Technical Reporting</div>

          <h1 style={styles.title}>Tech Team Hub</h1>

          <p style={styles.heroSubtitle}>

            Report generation, specialist case workflows and technical document tools.

          </p>

        </div>



        <section style={styles.card} className="tech-card">

          <h2 style={styles.sectionTitle}>Report Generation</h2>



          <p style={styles.helpText}>

            Normal Case, Add Comp, Certis and Atto use the PDF + interpretation

            JSON autoreporting workflow. External Results also requires the

            analytical JSON so long result tables can be verified and repaired,

            while its existing PDF-derived content is retained.

          </p>



          <div style={styles.reportGrid}>

            {REPORT_TYPES.map((type) => {

              const active = reportType === type.key;



              return (

                <button

                  key={type.key}

                  type="button"

                  onClick={() => {

                    setReportType(type.key);
                    setFtsMode("base");
                    setAdvancedDraft(null);

                    setError("");

                  }}

                  className={`tech-report-button${active ? " active" : ""}`}

                  style={{

                    ...styles.reportButton,

                    ...(active ? styles.reportButtonActive : {}),

                  }}

                >

                  {type.label}

                </button>

              );

            })}

          </div>



          {reportType === "outstanding_result_alcohol" && (
            <div style={{...styles.autoreportBox, marginTop:0, marginBottom:22}}>
              <div style={{fontWeight:900,color:"#00528c",marginBottom:10}}>Outstanding alcohol result type</div>
              <label style={{display:"flex",gap:9,alignItems:"center",marginBottom:9}}>
                <input type="radio" name="outstanding-alcohol-mode" checked={outstandingAlcoholMode==="standard"}
                  onChange={()=>{setOutstandingAlcoholMode("standard");setError("");}} /> Standard outstanding alcohol results
              </label>
              <label style={{display:"flex",gap:9,alignItems:"center"}}>
                <input type="radio" name="outstanding-alcohol-mode" checked={outstandingAlcoholMode==="blood"}
                  onChange={()=>{setOutstandingAlcoholMode("blood");setError("");}} /> Venepuncture blood addendum only (CDT, LFTs, MCV)
              </label>
              {outstandingAlcoholMode==="blood" && <p style={styles.smallHelp}>
                Upload the existing report PDF and analytical JSON below. Only reported venepuncture blood results will appear in the new addendum.
              </p>}
            </div>
          )}

          {reportType === "normal_case" && (
            <div style={{...styles.autoreportBox, marginTop:0,marginBottom:22}}>
              <div style={{fontWeight:900,color:"#00528c",marginBottom:10}}>FTS reporting mode</div>
              <div style={{display:"flex",gap:12,flexWrap:"wrap"}}>
                {[{id:"base",name:"Base — automatic"},{id:"advanced",name:"Advanced — Beta · expert review"}].map(m=>(
                  <button key={m.id} type="button" onClick={()=>{setFtsMode(m.id);setAdvancedDraft(null);setError("");}}
                    style={{...styles.secondaryBtn,background:ftsMode===m.id?"#00528c":"white",color:ftsMode===m.id?"white":"#00528c"}}>{m.name}</button>
                ))}
              </div>
              {ftsMode === "advanced" && <p style={{...styles.smallHelp,marginTop:12,marginBottom:0}}>
                BETA — review and approve automatically proposed interpretations, periods, justifications and consistency wording.
                The Base generator remains unchanged. For testing, do not release Advanced reports without manual verification.
              </p>}
            </div>
          )}

          <div style={styles.formGrid}>

            <label style={styles.field}>

              <span style={styles.label}>Selected report type</span>

              <input

                style={styles.input}

                value={selectedReportLabel}

                readOnly

              />

            </label>



            <label style={styles.field}>

              <span style={styles.label}>Your name</span>

              <select

                style={styles.input}

                value={expertName}

                onChange={(e) => setExpertName(e.target.value)}

              >

                <option value="">Select name...</option>



                {(reportType === "atto" ? ATTO_EXPERT_NAMES : EXPERT_NAMES).map((name) => (

                  <option key={name} value={name}>

                    {name}

                  </option>

                ))}

              </select>

            </label>



            <label style={{ ...styles.field, ...styles.fullWidth }}>

              <span style={styles.label}>Existing Report PDF</span>



              <input

                style={styles.fileInput}

                type="file"

                accept="application/pdf,.pdf"

                onChange={(e) => setPdf(e.target.files?.[0] || null)}

              />

            </label>

          </div>



          {requiresJson && (

            <>

              <div style={styles.autoreportBox} className="tech-nested-panel">

                <h3 style={styles.subTitle}>

                  {isExternalResults || isBloodAddendum || reportType === "outstanding_result_drugs" ? "Analytical JSON" : "Interpretation JSON"}

                </h3>



                <p style={styles.smallHelp}>

                  {isBloodAddendum

                    ? "Upload or paste the analytical JSON containing the venepuncture blood results. Other drug, EtG, EtPa and PEth results will be excluded."

                    : isExternalResults

                    ? "Upload or paste the original analytical JSON. It is used as the authoritative source for section numbers, barcodes and analytical results if the PDF table is incomplete. The existing External Results PDF content remains authoritative for its report wording/layout."

                    : "Upload a JSON file or paste the JSON directly. The text remains editable before the report is generated."}

                </p>



                <label style={styles.field}>

                  <span style={styles.label}>Load JSON file</span>



                  <input

                    style={styles.fileInput}

                    type="file"

                    accept="application/json,.json,text/plain,.txt"

                    onChange={handleJsonFile}

                  />

                </label>



                <label style={{ ...styles.field, marginTop: 14 }}>

                  <span style={styles.label}>Paste / edit JSON</span>



                  <textarea

                    style={styles.jsonTextarea}

                    value={interpretationJson}

                    onChange={(e) => {

                      setInterpretationJson(e.target.value);

                      setJsonStatus("");

                    }}

                    placeholder='Paste the interpretation JSON here, for example: {"report_pk": 12345, ...}'

                    spellCheck={false}

                  />

                </label>



                <div style={styles.inlineActions}>

                  <button

                    type="button"

                    className="tech-secondary-button"

                    style={styles.secondaryBtn}

                    onClick={() => validateJson(true)}

                  >

                    Validate JSON

                  </button>



                  {jsonStatus && (

                    <span style={styles.successText}>{jsonStatus}</span>

                  )}

                </div>

              </div>



              {isAutoreport && (

              <div style={styles.autoreportBox} className="tech-nested-panel">

                <h3 style={styles.subTitle}>

                  Additional Case Information

                </h3>



                <p style={styles.smallHelp}>

                  These selections are applied as the manual override layer

                  before the autoreporting interpretation pipeline runs.

                </p>



                {reportType === "atto" && (

                  <>

                    <div style={styles.overrideGrid}>

                      <label style={styles.field}>

                        <span style={styles.label}>Collection date override</span>

                        <input

                          style={styles.input}

                          type="date"

                          value={attoCollectionDate}

                          onChange={(e) => setAttoCollectionDate(e.target.value)}

                          required

                        />

                        <span style={styles.smallHelp}>

                          Used to recalculate all Atto sample periods before interpretation and table generation.

                        </span>

                      </label>



                      <label style={styles.field}>

                        <span style={styles.label}>Client full name</span>

                        <input

                          style={styles.input}

                          type="text"

                          value={attoClientName}

                          onChange={(e) => setAttoClientName(e.target.value)}

                          placeholder="e.g. Ms Jane Smith"

                        />

                        <span style={styles.smallHelp}>

                          Include title and full name. The surname will be capitalised in the Atto report.

                        </span>

                      </label>



                      <label style={styles.field}>

                        <span style={styles.label}>Instructor</span>

                        <input

                          style={styles.input}

                          type="text"

                          value={attoInstructorName}

                          onChange={(e) => setAttoInstructorName(e.target.value)}

                          placeholder="Enter the instructor exactly as it should appear in the report"

                        />

                      </label>

                    </div>

                    <div style={{ ...styles.fullWidth, marginTop: 18 }}>
                      <h4 style={styles.miniHeading}>Atto instructions</h4>
                      <p style={styles.smallHelp}>
                        Record which alternative specimens and alcohol blood markers were
                        specifically instructed. Alternative-specimen questions are only shown
                        where that matrix/testing combination exists in the uploaded JSON.
                      </p>

                      <div style={styles.overrideGrid}>
                        {attoTestingProfile.amphetaminePanelPresent && (
                          <label style={styles.checkboxLabel}>
                            <input
                              type="checkbox"
                              checked={attoAmphetamineOnlyInstructed}
                              onChange={(e) => setAttoAmphetamineOnlyInstructed(e.target.checked)}
                            />
                            <span>Amphetamine only instructed</span>
                          </label>
                        )}

                        {attoTestingProfile.alcohol && (
                          <label style={styles.checkboxLabel}>
                            <input type="checkbox"
                              checked={attoEtgOnly}
                              onChange={(e) => setAttoEtgOnly(e.target.checked)}
                            />
                            <span>EtG only instructed (no EtPa)</span>
                          </label>
                        )}

                        {attoTestingProfile.cocainePanelPresent && (
                          <label style={styles.checkboxLabel}>
                            <input
                              type="checkbox"
                              checked={attoCocaineNotDetected}
                              onChange={(e) => setAttoCocaineNotDetected(e.target.checked)}
                            />
                            <span>Cocaine not detected</span>
                          </label>
                        )}

                        {attoTestingProfile.nailAlcohol && (
                          <label style={styles.checkboxLabel}>
                            <input
                              type="checkbox"
                              checked={attoNailAlcoholInstructed}
                              onChange={(e) => setAttoNailAlcoholInstructed(e.target.checked)}
                            />
                            <span>Nail instructed for alcohol</span>
                          </label>
                        )}

                        {attoTestingProfile.nailDrugs && (
                          <label style={styles.checkboxLabel}>
                            <input
                              type="checkbox"
                              checked={attoNailDrugsInstructed}
                              onChange={(e) => setAttoNailDrugsInstructed(e.target.checked)}
                            />
                            <span>Nail instructed for drugs</span>
                          </label>
                        )}

                        {(attoTestingProfile.nailAlcohol || attoTestingProfile.nailDrugs) && !attoNailAlcoholInstructed && !attoNailDrugsInstructed && (
                          <label style={{...styles.field, width:"100%", marginTop:12}}>
                            <span style={styles.label}>Reason scalp hair was not provided</span>
                            <select style={styles.input} value={attoNailScalpReason} onChange={(e) => setAttoNailScalpReason(e.target.value)}>
                              <option value="">Not specified — leave receipt unchanged</option>
                              <option value="insufficient_length">Insufficient scalp hair available</option>
                              <option value="refused">Donor refused to provide a scalp hair sample</option>
                            </select>
                          </label>
                        )}

                        {attoTestingProfile.bodyHairAlcohol && (
                          <label style={styles.checkboxLabel}>
                            <input
                              type="checkbox"
                              checked={attoBodyHairAlcoholInstructed}
                              onChange={(e) => setAttoBodyHairAlcoholInstructed(e.target.checked)}
                            />
                            <span>Body hair instructed for alcohol</span>
                          </label>
                        )}

                        {attoTestingProfile.bodyHairDrugs && (
                          <label style={styles.checkboxLabel}>
                            <input
                              type="checkbox"
                              checked={attoBodyHairDrugsInstructed}
                              onChange={(e) => setAttoBodyHairDrugsInstructed(e.target.checked)}
                            />
                            <span>Body hair instructed for drugs</span>
                          </label>
                        )}
                      </div>

                      {attoTestingProfile.alcohol && (
                        <>
                          <h4 style={{ ...styles.miniHeading, marginTop: 16 }}>
                            Alcohol bloods instructed
                          </h4>
                          <div style={styles.overrideGrid}>
                            {!attoTestingProfile.cdtPresent && (
                              <label style={styles.checkboxLabel}>
                                <input type="checkbox" checked={attoCdtInstructed}
                                  onChange={(e) => setAttoCdtInstructed(e.target.checked)} />
                                <span>CDT</span>
                              </label>
                            )}
                            {!attoTestingProfile.lftsPresent && (
                              <label style={styles.checkboxLabel}>
                                <input type="checkbox" checked={attoLftsInstructed}
                                  onChange={(e) => setAttoLftsInstructed(e.target.checked)} />
                                <span>LFTs</span>
                              </label>
                            )}
                            {!attoTestingProfile.mcvPresent && (
                              <label style={styles.checkboxLabel}>
                                <input type="checkbox" checked={attoMcvInstructed}
                                  onChange={(e) => setAttoMcvInstructed(e.target.checked)} />
                                <span>MCV</span>
                              </label>
                            )}
                            {!attoTestingProfile.pethPresent && (
                              <label style={styles.checkboxLabel}>
                                <input type="checkbox" checked={attoPethInstructed}
                                  onChange={(e) => setAttoPethInstructed(e.target.checked)} />
                                <span>PEth</span>
                              </label>
                            )}
                          </div>

                          {((!attoTestingProfile.cdtPresent && attoCdtInstructed) || (!attoTestingProfile.lftsPresent && attoLftsInstructed) || (!attoTestingProfile.mcvPresent && attoMcvInstructed)) && (
                            <div style={{ ...styles.overrideGrid, marginTop: 14 }}>
                              {!attoTestingProfile.cdtPresent && attoCdtInstructed && (
                                <label style={styles.field}>
                                  <span style={styles.label}>CDT result (%)</span>
                                  <input
                                    style={styles.input}
                                    type="number"
                                    step="any"
                                    value={attoCdtResult}
                                    onChange={(e) => setAttoCdtResult(e.target.value)}
                                    placeholder="e.g. 1.3"
                                  />
                                </label>
                              )}

                              {!attoTestingProfile.lftsPresent && attoLftsInstructed && (
                                <>
                                  <label style={styles.field}>
                                    <span style={styles.label}>ALT result (IU/L)</span>
                                    <input
                                      style={styles.input}
                                      type="number"
                                      step="any"
                                      value={attoAltResult}
                                      onChange={(e) => setAttoAltResult(e.target.value)}
                                      placeholder="e.g. 26"
                                    />
                                  </label>
                                  <label style={styles.field}>
                                    <span style={styles.label}>AST result (IU/L)</span>
                                    <input
                                      style={styles.input}
                                      type="number"
                                      step="any"
                                      value={attoAstResult}
                                      onChange={(e) => setAttoAstResult(e.target.value)}
                                      placeholder="e.g. 28"
                                    />
                                  </label>
                                  <label style={styles.field}>
                                    <span style={styles.label}>GGT result (IU/L)</span>
                                    <input
                                      style={styles.input}
                                      type="number"
                                      step="any"
                                      value={attoGgtResult}
                                      onChange={(e) => setAttoGgtResult(e.target.value)}
                                      placeholder="e.g. 17"
                                    />
                                  </label>
                                </>
                              )}


                              {!attoTestingProfile.mcvPresent && attoMcvInstructed && (
                                <label style={styles.field}>
                                  <span style={styles.label}>MCV result (fL)</span>
                                  <input
                                    style={styles.input}
                                    type="number"
                                    step="any"
                                    value={attoMcvResult}
                                    onChange={(e) => setAttoMcvResult(e.target.value)}
                                    placeholder="e.g. 92"
                                  />
                                </label>
                              )}
                            </div>
                          )}

                          {((!attoTestingProfile.cdtPresent && attoCdtInstructed) || (!attoTestingProfile.lftsPresent && attoLftsInstructed) || (!attoTestingProfile.mcvPresent && attoMcvInstructed)) && (
                            <span style={styles.smallHelp}>
                              Manual blood values are used only when that analyte is not already
                              present in the uploaded analytical JSON.
                            </span>
                          )}
                        </>
                      )}
                    </div>



                    <div

                      style={{

                        ...styles.field,

                        ...styles.fullWidth,

                        marginTop: 16,

                      }}

                    >

                      <label

                        style={{

                          ...styles.checkboxLabel,

                          marginBottom: 8,

                        }}

                      >

                        <input

                          type="checkbox"

                          checked={attoNothingDeclared}

                          onChange={(e) =>

                            setAttoNothingDeclared(e.target.checked)

                          }

                        />

                        <span>Nothing declared</span>

                      </label>



                      <span style={styles.label}>Donor information</span>

                      <textarea

                        style={{

                          ...styles.donorTextarea,

                          opacity: attoNothingDeclared ? 0.6 : 1,

                        }}

                        value={donorInformation}

                        onChange={(e) => setDonorInformation(e.target.value)}

                        placeholder={

                          attoNothingDeclared

                            ? "Standard nothing-declared wording will be inserted automatically."

                            : "Enter donor information for the Atto report..."

                        }

                        rows={4}

                        disabled={attoNothingDeclared}

                      />



                      {attoNothingDeclared && (

                        <span style={styles.smallHelp}>

                          The standard nothing-declared donor paragraph will be

                          inserted automatically using the report client name.

                        </span>

                      )}

                    </div>



                                         {attoTestingProfile.alcohol && (
                       <div style={{ ...styles.fullWidth, marginTop: 18 }}>
                         <h4 style={styles.miniHeading}>Alcohol Declaration</h4>
                         <label style={styles.checkboxLabel}>
                           <input type="checkbox" checked={attoAlcoholAbstinenceDeclared}
                             onChange={(e) => setAttoAlcoholAbstinenceDeclared(e.target.checked)} />
                           <span>Abstinence from alcohol declared</span>
                         </label>
                         <span style={styles.smallHelp}>
                           Controls optional EtG abstinence interpretation only; PEth is interpreted separately.
                         </span>
                       </div>
                     )}

{attoCannabisTested && (

                      <div style={{ ...styles.fullWidth, marginTop: 18 }}>

                        <h4 style={styles.miniHeading}>Cannabis Declaration</h4>

                        <label style={{ ...styles.field, maxWidth: 360 }}>

                          <span style={styles.label}>Declared cannabis use?</span>

                          <select

                            style={styles.input}

                            value={attoCannabisUseDeclared}

                            onChange={(e) => setAttoCannabisUseDeclared(e.target.value)}

                          >

                            <option value="No">No</option>

                            <option value="Daily">Daily</option>

                            <option value="Frequent">Frequent</option>

                            <option value="Occasional">Occasional</option>

                            <option value="Infrequent">Infrequent</option>

                          </select>

                          <span style={styles.smallHelp}>

                            Shown only because cannabis testing was identified in the uploaded Atto JSON.

                          </span>

                        </label>

                      </div>

                    )}



                    <div style={{ ...styles.fullWidth, marginTop: 18 }}>

                      <h4 style={styles.miniHeading}>Hair Dye</h4>



                      <label style={styles.checkboxLabel}>

                        <input

                          type="checkbox"

                          checked={caseConsiderations.includes("Hair Dye")}

                          onChange={() => toggleInfluence("Hair Dye")}

                        />

                        <span>Hair dye present / relevant</span>

                      </label>



                      {caseConsiderations.includes("Hair Dye") && (

                        <>

                          <label

                            style={{

                              ...styles.checkboxLabel,

                              marginTop: 12,

                              marginBottom: 2,

                            }}

                          >

                            <input

                              type="checkbox"

                              checked={attoHairDyeMultipleApplications}

                              onChange={(e) =>

                                setAttoHairDyeMultipleApplications(e.target.checked)

                              }

                            />

                            <span>Multiple dye / bleach applications</span>

                          </label>



                          <div style={{ ...styles.overrideGrid, marginTop: 14 }}>

                          <label style={styles.field}>

                            <span style={styles.label}>Was the hair dye declared?</span>

                            <select

                              style={styles.input}

                              value={attoHairDyeDeclared}

                              onChange={(e) => setAttoHairDyeDeclared(e.target.value)}

                            >

                              <option value="Declared">Declared</option>

                              <option value="Not declared">Not declared</option>

                            </select>

                          </label>



                          <label style={styles.field}>

                            <span style={styles.label}>Hair dye timing</span>

                            <select

                              style={styles.input}

                              value={attoHairDyeTimingMode}

                              onChange={(e) => setAttoHairDyeTimingMode(e.target.value)}

                            >

                              <option value="date">Date / approximate date</option>

                              <option value="relative">Relative to collection date</option>

                            </select>

                          </label>



                          {attoHairDyeTimingMode === "date" ? (

                            <label style={styles.field}>

                              <span style={styles.label}>Hair dye date</span>

                              <input

                                style={styles.input}

                                type="date"

                                value={attoHairDyeDate}

                                onChange={(e) => setAttoHairDyeDate(e.target.value)}

                              />

                            </label>

                          ) : (

                            <label style={styles.field}>

                              <span style={styles.label}>Approximate timing before collection</span>

                              <select

                                style={styles.input}

                                value={attoHairDyeRelative}

                                onChange={(e) => setAttoHairDyeRelative(e.target.value)}

                              >

                                {ATTO_DYE_RELATIVE_OPTIONS.map((option) => (

                                  <option key={option} value={option}>

                                    {option}

                                  </option>

                                ))}

                              </select>

                            </label>

                          )}



                          <label style={styles.field}>

                            <span style={styles.label}>VDL location (cm from scalp)</span>

                            <input

                              style={styles.input}

                              type="number"

                              min="0"

                              max="12"

                              step="0.1"

                              inputMode="decimal"

                              value={attoHairDyeVdl}

                              onChange={(e) => setAttoHairDyeVdl(e.target.value)}

                              placeholder="0 to 12"

                            />

                            <span style={styles.smallHelp}>

                              Optional. Enter one number from 0 to 12 cm; decimals are allowed.

                            </span>

                          </label>

                          </div>

                        </>

                      )}

                    </div>

                  </>

                )}



                {reportType !== "atto" && (

                  <>

                <div style={styles.overrideGrid}>

                  <label style={styles.field}>

                    <span style={styles.label}>Blood tests instructed</span>



                    <select

                      style={styles.input}

                      value={overrides.blood_selection}

                      onChange={(e) =>

                        updateOverride("blood_selection", e.target.value)

                      }

                    >

                      {BLOOD_OPTIONS.map((option) => (

                        <option key={option} value={option}>

                          {option}

                        </option>

                      ))}

                    </select>

                  </label>



                  <label style={styles.field}>

                    <span style={styles.label}>PEth instructed</span>



                    <select

                      style={styles.input}

                      value={overrides.peth_instructed}

                      onChange={(e) =>

                        updateOverride("peth_instructed", e.target.value)

                      }

                    >

                      <option value="No">No</option>

                      <option value="Yes">Yes</option>

                    </select>

                  </label>



                  <label style={styles.field}>

                    <span style={styles.label}>Previous scalp sample site</span>



                    <select

                      style={styles.input}

                      value={overrides.previous_scalp_site}

                      onChange={(e) =>

                        updateOverride(

                          "previous_scalp_site",

                          e.target.value

                        )

                      }

                    >

                      {PREVIOUS_SCALP_SITE_OPTIONS.map((option) => (

                        <option key={option.value} value={option.value}>

                          {option.label}

                        </option>

                      ))}

                    </select>

                  </label>



                  {overrides.previous_scalp_site !== "No" && (

                    <label style={styles.field}>

                      <span style={styles.label}>

                        Previous-site growth rate

                      </span>



                      <select

                        style={styles.input}

                        value={overrides.previous_site_growth}

                        onChange={(e) =>

                          updateOverride(

                            "previous_site_growth",

                            e.target.value

                          )

                        }

                      >

                        {PREVIOUS_SITE_GROWTH_OPTIONS.map((option) => (

                          <option key={option} value={option}>

                            {option}

                          </option>

                        ))}

                      </select>

                    </label>

                  )}



                  <label style={styles.field}>

                    <span style={styles.label}>Medications</span>



                    <select

                      style={styles.input}

                      value={overrides.medications}

                      onChange={(e) =>

                        updateOverride("medications", e.target.value)

                      }

                    >

                      {MEDICATION_OPTIONS.map((option) => (

                        <option key={option} value={option}>

                          {option}

                        </option>

                      ))}

                    </select>

                  </label>

                </div>



                <h4 style={styles.miniHeading}>Case declarations</h4>



                <div style={styles.overrideGrid}>

                  <label style={styles.field}>

                    <span style={styles.label}>Cannabis use declared</span>



                    <select

                      style={styles.input}

                      value={overrides.cannabis_use}

                      onChange={(e) =>

                        updateOverride("cannabis_use", e.target.value)

                      }

                    >

                      {CANNABIS_OPTIONS.map((option) => (

                        <option key={option} value={option}>

                          {option}

                        </option>

                      ))}

                    </select>

                  </label>



                  <label style={styles.field}>

                    <span style={styles.label}>Previous DOA results</span>



                    <select

                      style={styles.input}

                      value={overrides.previous_doa}

                      onChange={(e) =>

                        updateOverride("previous_doa", e.target.value)

                      }

                    >

                      {PREVIOUS_DOA_OPTIONS.map((option) => (

                        <option key={option} value={option}>

                          {option}

                        </option>

                      ))}

                    </select>

                  </label>



                  <label style={styles.field}>

                    <span style={styles.label}>

                      Thermal straightening in previous 12 months

                    </span>



                    <select

                      style={styles.input}

                      value={overrides.thermal_straightening}

                      onChange={(e) =>

                        updateOverride(

                          "thermal_straightening",

                          e.target.value

                        )

                      }

                    >

                      {THERMAL_OPTIONS.map((option) => (

                        <option key={option} value={option}>

                          {option}

                        </option>

                      ))}

                    </select>

                  </label>



                  <label style={styles.field}>

                    <span style={styles.label}>Linked case</span>



                    <select

                      style={styles.input}

                      value={overrides.linked_case}

                      onChange={(e) =>

                        updateOverride("linked_case", e.target.value)

                      }

                    >

                      {LINKED_CASE_OPTIONS.map((option) => (

                        <option key={option} value={option}>

                          {option}

                        </option>

                      ))}

                    </select>

                  </label>



                  <label style={styles.field}>

                    <span style={styles.label}>Alcohol usage type</span>



                    <select

                      style={styles.input}

                      value={overrides.alcohol_usage}

                      onChange={(e) =>

                        updateOverride("alcohol_usage", e.target.value)

                      }

                    >

                      {ALCOHOL_OPTIONS.map((option) => (

                        <option key={option} value={option}>

                          {option}

                        </option>

                      ))}

                    </select>

                  </label>

                </div>



                <h4 style={styles.miniHeading}>Samples stored</h4>



                <div style={styles.checkboxGrid}>

                  {SAMPLE_STORAGE_OPTIONS.map((name) => (

                    <label key={name} style={styles.checkboxLabel}>

                      <input

                        type="checkbox"

                        checked={overrides.samples_stored.includes(name)}

                        onChange={() => toggleStoredSample(name)}

                      />



                      <span>{name}</span>

                    </label>

                  ))}

                </div>

                  </>

                )}

              </div>

              )}

            </>

          )}



          {reportType !== "atto" && (

            <div style={styles.influenceBox} className="tech-nested-panel">

              <h3 style={styles.subTitle}>

                Influences / Case Considerations

              </h3>



              <div style={styles.checkboxGrid}>

                {INFLUENCES.map((name) => (

                  <label key={name} style={styles.checkboxLabel}>

                    <input

                      type="checkbox"

                      checked={caseConsiderations.includes(name)}

                      onChange={() => toggleInfluence(name)}

                    />



                    <span>{name}</span>

                  </label>

                ))}

              </div>

            </div>

          )}



          {reportType === "normal_case" && ftsMode === "advanced" && advancedDraft && (
            <div style={{...styles.autoreportBox,marginTop:20,display:"flex",justifyContent:"space-between",alignItems:"center",gap:12,flexWrap:"wrap"}}>
              <div><strong>Advanced expert review</strong><p style={{...styles.smallHelp,margin:"4px 0 0"}}>{wizardItems.filter(x=>x.approved).length} of {wizardItems.length} subjects approved · Progress retained until you leave or refresh this page</p></div>
              <button type="button" style={styles.generateBtn} onClick={()=>{setAdvancedWizardOpen(true);setAdvancedWizardError("");if(advancedTab===-2&&!wizardComplete)wizardGo(-3);}}>{advancedWizardOpen?"Review open":"Open expert review"}</button>
            </div>
          )}
          {reportType === "normal_case" && ftsMode === "advanced" && advancedDraft && advancedWizardOpen && (
            <div role="dialog" aria-modal="true" aria-label="Advanced expert review wizard" style={{position:"fixed",inset:0,zIndex:10000,background:"rgba(15,32,51,.74)",display:"flex",alignItems:"center",justifyContent:"center",padding:12}}>
              <div style={{width:"min(1380px,100%)",height:"min(94vh,980px)",background:"#fff",display:"flex",flexDirection:"column",borderRadius:16,overflow:"hidden",boxShadow:"0 15px 60px rgba(0,0,0,.3)"}}>
                <div style={{padding:"14px 22px",borderBottom:"1px solid #dae4ef",display:"flex",gap:12,justifyContent:"space-between",alignItems:"center",flexWrap:"wrap"}}>
                  <div><strong style={{fontSize:18,color:"#00528c"}}>FTS Advanced expert review</strong><div style={{fontSize:12,color:"#526778"}}>{wizardFinished?"Final verification":advancedTab===-3?"01 · Interpretation matrix":`${wizardIndex+1} of ${wizardItems.length} · ${wizardItems[wizardIndex]?.label||"Subject"} · ${advancedPanel==="interpretations"?"Interpretation preview":advancedPanel==="justifications"?"Justifications":"Consistency"}`}</div></div>
                  <button type="button" style={styles.secondaryBtn} onClick={()=>setAdvancedWizardOpen(false)}>Save & close ×</button>
                </div>
                <div style={{display:"flex",gap:5,padding:"12px 22px",overflowX:"auto",borderBottom:"1px solid #dae4ef"}}>
                  <button type="button" onClick={()=>wizardGo(-3)} style={{whiteSpace:"nowrap",border:"1px solid #bdcfdd",borderRadius:20,padding:"7px 13px",background:advancedTab===-3?"#00528c":"#f6f8fb",color:advancedTab===-3?"white":"#183a58",fontWeight:750,cursor:"pointer"}}>◫ Interpretation matrix</button>
                  {wizardItems.map((it,i)=><button key={it.id} type="button" onClick={()=>wizardGo(it.id)} style={{whiteSpace:"nowrap",border:"1px solid #bdcfdd",borderRadius:20,padding:"7px 12px",fontWeight:600,background:advancedTab===it.id?"#00528c":it.approved?"#e9f7ee":"#f6f8fb",color:advancedTab===it.id?"white":"#183a58",cursor:"pointer"}}>{i+1}. {it.label} {it.approved?"✓":""}</button>)}
                  <button type="button" onClick={()=>wizardGo(-2)} style={{whiteSpace:"nowrap",border:"1px solid #bdcfdd",borderRadius:20,padding:"7px 12px",background:wizardFinished?"#00528c":"#f6f8fb",color:wizardFinished?"white":"#183a58",cursor:"pointer"}}>Final review</button>
                </div>
                {!wizardFinished&&advancedTab!==-3&&<div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:6,padding:"10px 22px"}}>{wizardStages.map((v,i)=><div key={v} style={{textAlign:"center",padding:7,borderRadius:7,fontSize:12,fontWeight:650,background:advancedPanel===v?"#e0ecf6":"#f4f6f9",color:advancedPanel===v?"#00528c":"#5d6977"}}>{i+1}. {v==="interpretations"?"Interpretation":v==="justifications"?"Justifications":"Consistency"}</div>)}</div>}
                <div id="fts-advanced-wizard-scroll" style={{overflowY:"auto",minHeight:0,flex:1,padding:"10px 22px 18px"}}>
              {advancedTab===-3 && <div className="adv-matrix-board">
                <div className="adv-matrix-header"><div><div className="adv-eyebrow">FTS · EXPERT WORKSPACE</div><h2>Interpretation matrix</h2><p>Set the expert opinion for each tested sample. Select a coloured cell to set frequency, alternatives and reasoning. Drug interpretations remain editable later.</p></div><div className="adv-progress"><strong>{matrixReviewed} / {matrixDrugTotal}</strong><span>Cells reviewed</span></div></div>
                <div className="adv-legend">{["use","exposure","two_equally_likely","insufficient","abstinence"].map(key=><span key={key}><i style={{background:ADV_CELL_STYLES[key].color}}/>{ADV_CELL_STYLES[key].label}</span>)}</div>
                {caseConsiderations.includes("Hair Dye")&&matrixColumns.some(c=>c.scalp)&&<div className="adv-dye-control"><strong>Cosmetic treatment boundary</strong><p>Choose the first potentially affected scalp section. A dashed divider will appear before it. This changes the suggested use-frequency scale but does not decide the interpretation.</p>{[...new Set(matrixColumns.filter(c=>c.scalp).map(c=>c.unit.sample_index))].map(index=>{
                  const columns=matrixColumns.filter(c=>c.scalp&&c.unit.sample_index===index);
                  return <label key={index}>Scalp sample {Number(index)+1}<select value={matrixDyeStarts[index]||""} onChange={e=>setMatrixDyeStarts(v=>({...v,[index]:e.target.value}))}><option value="">Boundary not specified</option>{columns.map(c=>{const n=Number(/Section\s*(\d+)/i.exec(String(c.unit.label||""))?.[1]||Number(c.unit.test_sample_index)+1);return <option key={c.key} value={n}>Before Section {n}</option>;})}</select></label>;
                })}</div>}
                {advancedDraft.alcohol?.enabled&&<div className="adv-alcohol-board"><div className="adv-eyebrow">ALCOHOL REVIEW · EtG & PEth</div><p>Record an initial visual assessment for each relevant marker. These choices are review aids, not analytical results. The approved alcohol narrative is reviewed in the subsequent Alcohol stage.</p><div className="adv-alcohol-grid">{[{id:"etg",name:"EtG",help:"Hair / nail EtG"},{id:"peth",name:"PEth",help:"Blood PEth"}].map(marker=><div className="adv-alcohol-tile" key={marker.id}><strong>{marker.name}</strong><small>{marker.help}</small><select value={matrixAlcohol[marker.id]||""} onChange={e=>{setMatrixAlcohol(v=>({...v,[marker.id]:e.target.value}));setSummaryApproved(false);setAdvancedDraft(prev=>({...prev,alcohol:{...prev.alcohol,approved:false}}));}}><option value="">Not assessed / not applicable</option><option value="non_excessive">Non-excessive consumption</option><option value="excessive">Excessive consumption</option><option value="low">Low-level consumption</option><option value="abstinence">Abstinence / no evidence</option><option value="inconclusive">Inconclusive</option></select></div>)}</div></div>}
                {matrixColumns.length>0?<div className="adv-matrix-scroll"><table className="adv-matrix-table"><thead><tr><th className="adv-sticky-name">Substance</th>{matrixColumns.map(c=><th key={c.key} className={matrixIsDyed(c.unit)&&matrixDyeStarts[c.unit.sample_index]===String(Number(/Section\s*(\d+)/i.exec(String(c.unit.label||""))?.[1]||Number(c.unit.test_sample_index)+1))?"adv-dye-start":""}><div>{c.unit.label||c.unit.matrix||"Sample"}</div><small>{c.scalp?`Scalp ${Number(c.unit.sample_index)+1}`:c.unit.matrix||"Alternative specimen"}</small></th>)}</tr></thead>
                <tbody>{(advancedDraft.drugs||[]).map((d,di)=><tr key={d.id||di}><th className="adv-sticky-name">{d.name}<small>{d.review_mode==="original"?"Original opinion retained":d.review_mode==="manual"?"Manual opinion":`${(d.decisions||[]).filter(x=>x.type!=="unreviewed").length} decisions`}</small></th>{matrixColumns.map(c=>{
                  const unit=(d.units||[]).find(u=>advMatrixColumn(u)===c.key);
                  const dec=unit&&(d.decisions||[]).find(x=>x.id===unit.id);
                  const selected=!!unit&&matrixSelected?.di===di&&matrixSelected?.unitId===unit.id;
                  const dyed=matrixIsDyed(c.unit);
                  const boundary=dyed&&matrixDyeStarts[c.unit.sample_index]===String(Number(/Section\s*(\d+)/i.exec(String(c.unit.label||""))?.[1]||Number(c.unit.test_sample_index)+1));
                  const value=dec?.type||"unreviewed";const style=ADV_CELL_STYLES[value];
                  return <td key={c.key} className={boundary?"adv-dye-start":""}>{unit?<button type="button" className={`adv-matrix-cell ${selected?"selected":""}`} title={`${d.name} · ${unit.label} · ${unit.period||""} · ${style.label}${dyed?" · Potential dye effect":""}`} style={{background:style.color,color:style.ink}} onClick={()=>setMatrixSelected({di,unitId:unit.id})}><strong>{advCellNumber(dec,dyed)|| (value==="unreviewed"?"+":"✓")}</strong>{unit.all_nd===false&&["abstinence","non_use"].includes(value)&&!dec?.reason&&<em title="Detected results: explanation required">!</em>}</button>:<span className="adv-matrix-absent">—</span>}</td>;
                })}</tr>)}</tbody></table></div>:<div className="adv-empty">No analysable drug-section matrix was returned. Existing per-drug interpretation review is still available.</div>}
                {matrixSelected&&(()=>{const d=advancedDraft.drugs?.[matrixSelected.di];const u=d?.units?.find(x=>x.id===matrixSelected.unitId);if(!u)return null;const dec=d.decisions?.find(x=>x.id===u.id)||{};const dyed=matrixIsDyed(u);const isGreen=["abstinence","non_use"].includes(dec.type);return <div className="adv-cell-editor"><div className="adv-editor-top"><div><div className="adv-eyebrow">SELECTED CELL</div><h3>{d.name} <span>· {u.label||u.matrix}</span></h3><p>{u.period||advFormatRange([u])} {dyed?"· Potentially dye affected":""} {u.all_nd===true?"· All ND":u.all_nd===false?"· Detected findings":""}</p></div><button type="button" className="adv-editor-close" onClick={()=>setMatrixSelected(null)}>✕ Close</button></div>
                  <div className="adv-choice-grid">{ADV_MATRIX_TYPES.map(type=><button type="button" key={type} className={dec.type===type?"adv-choice active":"adv-choice"} style={{"--choice":ADV_CELL_STYLES[type].color}} onClick={()=>matrixSetDecision(matrixSelected.di,u,{type})}><span className="adv-choice-dot"/>{ADV_CELL_STYLES[type].label}</button>)}</div>
                  {["use","exposure","two_equally_likely"].includes(dec.type)&&<div className="adv-fields"><label><strong>{dec.type==="exposure"?"Exposure level":"Use frequency"}</strong><select value={dec.frequency||""} onChange={e=>matrixSetDecision(matrixSelected.di,u,{frequency:e.target.value})}><option value="">Choose…</option>{(dec.type==="exposure"?ADV_EXPOSURE_FREQ:dyed?ADV_DYED_USE_FREQ:ADV_USE_FREQ).map((f,i)=><option value={f} key={f}>{i+1} · {f}</option>)}{dec.frequency&&!([...ADV_USE_FREQ,...ADV_DYED_USE_FREQ,...ADV_EXPOSURE_FREQ].includes(dec.frequency))&&<option value={dec.frequency}>Custom · {dec.frequency}</option>}</select></label>{dec.type==="two_equally_likely"&&<label><strong>Alternative exposure level</strong><select value={dec.exposure_frequency||""} onChange={e=>matrixSetDecision(matrixSelected.di,u,{exposure_frequency:e.target.value})}><option value="">Choose…</option>{ADV_EXPOSURE_FREQ.map((f,i)=><option key={f} value={f}>{i+1} · {f}</option>)}</select></label>}<label><strong>Custom frequency override</strong><input value={dec.frequency||""} onChange={e=>matrixSetDecision(matrixSelected.di,u,{frequency:e.target.value})} placeholder="Type precise expert wording"/></label></div>}
                  <label className="adv-reason"><strong>{isGreen&&u.all_nd===false?"Explanation required — detected findings":"Explanation / case-specific consideration"}</strong><textarea rows={2} value={dec.reason||""} onChange={e=>matrixSetDecision(matrixSelected.di,u,{reason:e.target.value})} placeholder="Record the scientific basis or limitation for this decision…"/></label>
                  {isGreen&&u.all_nd===false&&<p className="adv-warning">A green conclusion with detected analytical findings requires a written explanation. This will be retained for expert review; ensure the final justification and interpretation also explain the finding.</p>}
                  {dyed&&<p className="adv-note">Potential cosmetic treatment: the shortened use-frequency presets are offered, but every category and custom wording remains available.</p>}
                </div>})()}
                <div className="adv-matrix-bottom"><div><strong>Workflow</strong><p>Complete the grid, then review each drug’s generated interpretation and table, justifications and consistency before final approval.</p></div><button type="button" style={styles.secondaryBtn} onClick={()=>{setMatrixSelected(null);wizardGo(wizardItems[0]?.id??-2);}}>Proceed to detailed review →</button></div>
              </div>}
              {advancedTab >= 0 && advancedDraft.drugs[advancedTab] && (()=>{
                const d=advancedDraft.drugs[advancedTab];
                return <>

                  {advancedPanel === "interpretations" && <div>
                    <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:12,padding:10,borderRadius:10,background:"#f4f8fc",border:"1px solid #d1e0ed"}}>
                      <button type="button" style={{...styles.secondaryBtn,background:d.review_mode==="original"?"#d5eadd":"white",fontWeight:d.review_mode==="original"?750:500}} onClick={()=>editAdvancedDrug(advancedTab,{review_mode:"original"})}>✓ Keep original interpretation</button>
                      <button type="button" style={{...styles.secondaryBtn,background:d.review_mode==="manual"?"#dcebf8":"white",fontWeight:d.review_mode==="manual"?750:500}} onClick={()=>editAdvancedDrug(advancedTab,{review_mode:"manual",narrative_mode:"manual"})}>Edit wording manually</button>
                      <button type="button" style={{...styles.secondaryBtn,background:d.review_mode==="sections"?"#dcebf8":"white",fontWeight:d.review_mode==="sections"?750:500}} onClick={()=>editAdvancedDrug(advancedTab,{review_mode:"sections",narrative_mode:"generated"})}>Change section decisions</button>
                    </div>
                    {d.analytical_all_nd && <div style={{marginBottom:12,padding:10,border:"1px solid #e2c989",borderRadius:8,background:"#fff9e9",fontSize:12,color:"#57431b"}}><strong>All relevant analytical findings are ND.</strong> {d.declared_cannabis_use ? "Cannabis use was declared. Decide whether this warrants an expert use interpretation despite ND, or whether the report should retain a non-use/ND conclusion. " : "The existing expert opinion may still include contextual use or exposure. "}Review the evidence and timing carefully; no analytical detection has been inferred.</div>}
                    <p style={{...styles.smallHelp,marginBottom:12}}>Keeping or manually editing the existing FTS interpretation does not require assigning new section conclusions. Select “Change section decisions” only if you want to override section-by-section findings.</p>
                    <div style={{padding:14,background:"#f0f6fb",border:"1px solid #bbd1e4",borderRadius:12,marginBottom:16}}>
                      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:8,flexWrap:"wrap"}}>
                        <h4 style={{...styles.miniHeading,margin:0}}>Expert interpretation — report wording</h4>

                      </div>
                      <p style={{...styles.smallHelp,marginTop:8}}>{d.review_mode==="original"?"Original automatic opinion — review and approve without re-entering periods.":d.review_mode==="manual"?"You can edit the existing opinion directly; original structured periods remain unchanged.":"Live wording updates from the section groups. Expert review is required."}</p>
                      {d.review_mode==="manual" || (d.review_mode==="sections" && d.narrative_mode==="manual")?
                        <textarea style={{...styles.jsonTextarea,minHeight:140}} value={d.interpretation_text||""} onChange={e=>editAdvancedDrug(advancedTab,{interpretation_text:e.target.value})}/>:
                        <div style={{whiteSpace:"pre-wrap",lineHeight:1.65,color:"#1b2c3e",marginTop:8}}>{d.interpretation_text||"Select the group interpretations below."}</div>}
                      {d.review_mode==="manual" && <button type="button" style={{...styles.secondaryBtn,marginTop:8}} onClick={()=>editAdvancedDrug(advancedTab,{review_mode:"original"})}>Restore and keep original automatic opinion</button>}
                    </div>
                    <details style={{marginTop:12,marginBottom:12,border:"1px solid #c7d6e5",borderRadius:10,padding:12}} open>
                      <summary style={{cursor:"pointer",fontWeight:700,color:"#00528c"}}>Live mini-table preview — {d.name}</summary>
                      <p style={{...styles.smallHelp,margin:"7px 0"}}>Generated from your selected interpretation groups. Edit frequencies and groups below; choose the declaration classification on the Consistency step. Sample dates remain sourced from the analytical JSON.</p>
                      <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}><tbody>
                        <tr><th style={{background:"#d9e1f2",border:"1px solid #b7c9e8",textAlign:"left",padding:7}}>INTERPRETATION</th><td style={{border:"1px solid #b7c9e8",padding:7}}>{d.review_mode==="sections"?(advBuildPeriodGroups(d).some(x=>x.type==="use")?"USE":advBuildPeriodGroups(d).some(x=>x.type==="exposure")?"EXPOSURE":"INCONCLUSIVE"):(d.auto_scenario||"—")}</td></tr>
                        {(d.review_mode==="sections"?advBuildPeriodGroups(d):d.periods||[]).filter(g=>["use","exposure"].includes(g.type)).map((g,i)=><React.Fragment key={i}>
                          <tr><th style={{background:"#d9e1f2",border:"1px solid #b7c9e8",textAlign:"left",padding:7}}>{g.type==="use"?"FREQUENCY OF USE":"LEVEL OF EXPOSURE"} {i+1}</th><td style={{border:"1px solid #b7c9e8",padding:7}}>{d.review_mode==="sections"?<input aria-label={`Frequency for interpretation group ${i+1}`} style={{...styles.input,padding:"4px 7px"}} value={g.frequency||""} onChange={e=>{const groupIds=new Set((g.units||[]).map(u=>u.id));editAdvancedDrug(advancedTab,{decisions:(d.decisions||[]).map(x=>groupIds.has(x.id)?{...x,frequency:e.target.value}:x)});}}/>:(g.frequency||"—")}</td></tr>
                          <tr><th style={{background:"#d9e1f2",border:"1px solid #b7c9e8",textAlign:"left",padding:7}}>{g.type==="use"?"USE PERIOD":"EXPOSURE WINDOW"} {i+1}</th><td style={{border:"1px solid #b7c9e8",padding:7}}>{g.period||"—"}</td></tr>
                        </React.Fragment>)}
                        {(d.review_mode==="sections"?advBuildPeriodGroups(d):d.periods||[]).filter(g=>["insufficient","insufficient_dye"].includes(g.type)).map((g,i)=><tr key={i}><th style={{background:"#d9e1f2",border:"1px solid #b7c9e8",textAlign:"left",padding:7}}>UNABLE TO ASSESS PERIOD</th><td style={{border:"1px solid #b7c9e8",padding:7}}>{g.period||"—"}</td></tr>)}
                        {String(d.name||"").toLowerCase().includes("cocaine")&&<tr><th style={{background:"#d9e1f2",border:"1px solid #b7c9e8",textAlign:"left",padding:7}}>FORM USED</th><td style={{border:"1px solid #b7c9e8",padding:7}}>{d.form||"—"}</td></tr>}
                        <tr><th style={{background:"#d9e1f2",border:"1px solid #b7c9e8",textAlign:"left",padding:7}}>DECLARATION</th><td style={{border:"1px solid #b7c9e8",padding:7}}><select aria-label="Declaration consistency classification" style={{...styles.input,padding:"4px 7px"}} value={d.declaration_status||""} onChange={e=>editAdvancedDrug(advancedTab,{declaration_status:e.target.value})}><option value="">Automatic (review original interpretation)</option><option value="CONSISTENT">CONSISTENT</option><option value="INCONSISTENT">INCONSISTENT</option><option value="UNABLE TO ASSESS">UNABLE TO ASSESS</option></select></td></tr>
                      </tbody></table>
                    </details>
                    {d.review_mode==="sections" && <>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:8,flexWrap:"wrap",marginBottom:10}}>
                      <h4 style={{...styles.miniHeading,margin:0}}>Section interpretation groups</h4>
                      <button type="button" style={styles.secondaryBtn} onClick={()=>editAdvancedDrug(advancedTab,{decisions:(d.decisions||[]).map(x=>({...x,group_previous:false}))})}>Separate all sections</button>
                    </div>
                    <p style={styles.smallHelp}>Choose an end section for each group (e.g. Section 3 through Section 6). Only adjacent sections from the same scalp sample can join. Alternative samples stay separate. Dates are calculated from the uploaded JSON.</p>
                    {!(d.units||[]).length && <p style={{...styles.smallHelp,color:"#991b1b"}}>No matching analytical sample sections could be resolved. Check the sample information before approving.</p>}
                    {advBuildPeriodGroups(d).map((group,gi)=>{
                      const first=group.units[0];
                      const last=group.units[group.units.length-1];
                      const index=(d.units||[]).findIndex(u=>u.id===first.id);
                      const possible=[first];
                      for(let i=index+1;i<(d.units||[]).length;i++){
                        if(!advCanGroupUnits(d.units[i-1],d.units[i]))break;
                        possible.push(d.units[i]);
                      }
                      const groupIds=new Set(group.units.map(u=>u.id));
                      const updateGroup=change=>{
                        const decisions=(d.decisions||[]).map(x=>groupIds.has(x.id)?{...x,...change}:x);
                        editAdvancedDrug(advancedTab,{decisions});
                      };
                      return <div key={first.id} style={{padding:"12px 14px",background:"white",border:"1px solid #cfdae5",borderRadius:10,marginBottom:8}}>
                        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:10,flexWrap:"wrap",marginBottom:8}}>
                          <strong style={{color:"#00528c",fontSize:15}}>{advGroupLabel(group.units)}{!/scalp/i.test(first.matrix||"")?` · ${first.matrix}`:""}</strong>
                          <span style={{fontSize:12,color:"#586b7d"}}>{group.period}</span>
                        </div>
                        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(180px,1fr))",gap:10}}>
                          {possible.length>1 && <label style={styles.field}><span style={styles.label}>Group through</span><select style={styles.input} value={last.id} onChange={e=>editAdvancedDrug(advancedTab,{decisions:advSetGroupEnd(d,group,e.target.value)})}>
                            {possible.map((u,i)=><option key={u.id} value={u.id}>{advGroupLabel(possible.slice(0,i+1))}</option>)}
                          </select></label>}
                          <label style={styles.field}><span style={styles.label}>Interpretation</span><select style={styles.input} value={group.type} onChange={e=>updateGroup({type:e.target.value,frequency:"",exposure_frequency:"",reason:""})}>{ADV_TYPES.map(([v,label])=><option key={v} value={v}>{label}</option>)}</select></label>
                          {["use","exposure","two_equally_likely"].includes(group.type)&&<label style={styles.field}><span style={styles.label}>{group.type==="exposure"?"Exposure frequency":"Use frequency"}</span><AdvFreqSelect kind={group.type==="exposure"?"exposure":"use"} dyed={group.units.some(matrixIsDyed)} value={group.frequency} onChange={v=>updateGroup({frequency:v})}/></label>}
                          {group.type==="two_equally_likely"&&<label style={styles.field}><span style={styles.label}>Exposure scenario</span><AdvFreqSelect kind="exposure" value={group.exposure_frequency} onChange={v=>updateGroup({exposure_frequency:v})}/></label>}
                          {["insufficient","insufficient_dye","exposure"].includes(group.type)&&<label style={styles.field}><span style={styles.label}>Possible explanation (for justification suggestions)</span><select style={styles.input} value={group.reason||""} onChange={e=>updateGroup({reason:e.target.value})}>
                            <option value="">Not specified</option><option value="carry_over">Potential carry-over</option><option value="passive_exposure">Passive exposure</option><option value="carry_over_exposure">Carry-over and passive exposure</option><option value="dye">Cosmetic treatment</option>
                          </select></label>}
                        </div>
                        {(["use","exposure","two_equally_likely"].includes(group.type))&&<details style={{marginTop:8}}><summary style={{cursor:"pointer",fontSize:12}}>Custom frequency wording</summary><input style={{...styles.input,marginTop:5}} value={group.frequency||""} onChange={e=>updateGroup({frequency:e.target.value})} placeholder="Expert frequency wording"/></details>}
                      </div>;
                    })}
                    <p style={{...styles.smallHelp,marginTop:8}}>{advBuildPeriodGroups(d).length} interpretation group(s). Group selections change the narrative and reported periods, not original analytical results.</p>
                    <label style={{...styles.field,marginTop:10}}><span style={styles.label}>Additional summary comment (optional)</span><input style={styles.input} value={d.summary_note||""} onChange={e=>editAdvancedDrug(advancedTab,{summary_note:e.target.value})} placeholder="e.g. followed by a recent period of abstinence"/></label>
                    {d.name.toLowerCase().includes("cocaine")&&<label style={{...styles.field,marginTop:10}}><span style={styles.label}>Form of cocaine (for detailed interpretation)</span><select style={styles.input} value={d.form||""} onChange={e=>editAdvancedDrug(advancedTab,{form:e.target.value})}><option value="">Not specified</option><option value="Powder, possibly including crack">Powder, possibly including crack</option><option value="Crack, possibly including powder">Crack, possibly including powder</option><option value="Unable to determine">Unable to determine</option></select></label>}
                    </>}
                  </div>}
                  {advancedPanel === "justifications" && <div>
                    <h4 style={styles.miniHeading}>Justification bank — {d.name}</h4>
                    <p style={styles.smallHelp}>Generated paragraphs are selected initially; additional case-derived texts are offered below. Edit, select and reorder. Suggestions update with your section-level decisions. Original paragraphs remain accessible; warnings indicate possible contradictions. Review underlying analytical support and wording before selecting.</p>
                    {advReasonSuggestions(d).filter(j=>!(d.justifications||[]).some(x=>x.id===j.id)).map(j=><div key={j.id} style={{background:"#eef6fc",border:"1px solid #b7d1e6",borderRadius:10,padding:12,marginBottom:8}}>
                      <strong style={{color:"#00528c"}}>Suggested — {j.title}</strong>
                      <p style={{whiteSpace:"pre-wrap",fontSize:13,lineHeight:1.5}}>{j.text}</p>
                      <button type="button" style={styles.secondaryBtn} onClick={()=>editAdvancedDrug(advancedTab,{justifications:[...d.justifications,{...j,selected:true}]})}>Add editable justification</button>
                    </div>)}
                    {(d.justifications||[]).map((j,i)=><div key={j.id+"_"+i} style={{padding:14,border:"1px solid #d6dde8",borderRadius:12,marginBottom:10}}>
                      <label style={styles.checkboxLabel}><input type="checkbox" checked={!!j.selected} onChange={e=>editAdvancedDrug(advancedTab,{justifications:d.justifications.map((p,k)=>k===i?{...p,selected:e.target.checked}:p)})}/><strong>{j.title}</strong></label>
                      <span style={styles.smallHelp}>Source: {j.source||"custom"} · {advSuggestion(j,d.decisions,d.form)}</span>
                      <textarea style={{...styles.donorTextarea,marginTop:8}} rows={4} value={j.text||""} onChange={e=>editAdvancedDrug(advancedTab,{justifications:d.justifications.map((p,k)=>k===i?{...p,text:e.target.value}:p)})}/>
                      <div style={{display:"flex",gap:8,flexWrap:"wrap",marginTop:8}}>
                        <button type="button" style={styles.secondaryBtn} disabled={i===0} onClick={()=>{const a=[...d.justifications];[a[i-1],a[i]]=[a[i],a[i-1]];editAdvancedDrug(advancedTab,{justifications:a});}}>↑ Up</button>
                        <button type="button" style={styles.secondaryBtn} disabled={i===d.justifications.length-1} onClick={()=>{const a=[...d.justifications];[a[i],a[i+1]]=[a[i+1],a[i]];editAdvancedDrug(advancedTab,{justifications:a});}}>↓ Down</button>
                        <button type="button" style={styles.secondaryBtn} onClick={()=>editAdvancedDrug(advancedTab,{justifications:d.justifications.filter((_,k)=>k!==i)})}>Remove</button>
                      </div>
                    </div>)}
                    <button type="button" style={styles.secondaryBtn} onClick={()=>editAdvancedDrug(advancedTab,{justifications:[...d.justifications,{id:`custom_${Date.now()}`,title:"Custom justification",text:"",selected:true,source:"expert"}]})}>+ Add custom justification</button>
                    <h4 style={styles.miniHeading}>Assembled justification preview</h4>
                    <div style={{padding:15,background:"white",whiteSpace:"pre-wrap",borderRadius:12,border:"1px solid #d6dde8"}}>{d.justifications.filter(p=>p.selected).map(p=>p.text.replace(/<br\s*\/?\s*>/gi,"\n")).join("\n\n")}</div>
                  </div>}
                  {advancedPanel === "consistency" && <div>
                    <h4 style={styles.miniHeading}>Consistency with declaration</h4>
                    <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:12}}>
                      <button type="button" style={styles.secondaryBtn} onClick={()=>editAdvancedDrug(advancedTab,{consistency_text:`${advancedDraft.client_name||"The client"} did not declare using ${d.name.toLowerCase()} during the period covered by the hair sample. This is not consistent with my interpretation.`})}>No use declared / use indicated</button>
                      <button type="button" style={styles.secondaryBtn} onClick={()=>editAdvancedDrug(advancedTab,{consistency_text:`${advancedDraft.client_name||"The client"} did not declare using ${d.name.toLowerCase()} during the period covered by the hair sample. This is consistent with my interpretation.\n\nWhilst they did not declare any exposure to ${d.name.toLowerCase()}, which is inconsistent with my interpretation, it is feasible for them to have been unaware of any exposure.`})}>No use declared / minimal exposure (including unreported exposure)</button>
                      <button type="button" style={styles.secondaryBtn} onClick={()=>editAdvancedDrug(advancedTab,{consistency_text:`${advancedDraft.client_name||"The client"} declared using ${d.name.toLowerCase()} daily during the period covered by the hair sample. The levels detected in the hair are consistent with this declaration.`})}>Daily declared (verify)</button>
                    </div>
                    <label style={{...styles.field,marginTop:12}}><span style={styles.label}>Declaration shown in the mini-table — expert decision</span>
                      <select style={styles.input} value={d.declaration_status||""} onChange={e=>editAdvancedDrug(advancedTab,{declaration_status:e.target.value})}>
                        <option value="">Keep automatic table value</option>
                        <option value="CONSISTENT">CONSISTENT</option>
                        <option value="INCONSISTENT">INCONSISTENT</option>
                        <option value="UNABLE TO ASSESS">UNABLE TO ASSESS</option>
                      </select></label>
                    <p style={styles.smallHelp}>This is an explicit expert-approved classification, not inferred from the written consistency paragraph.</p>
                    <textarea style={styles.jsonTextarea} value={d.consistency_text||""} onChange={e=>editAdvancedDrug(advancedTab,{consistency_text:e.target.value})}/>
                  </div>}

                </>;
              })()}
              {advancedTab===-1 && advancedDraft.alcohol?.enabled && <div>
                <h4 style={styles.miniHeading}>Alcohol — {advancedPanel==="interpretations"?"Interpretation":advancedPanel==="justifications"?"Justifications":"Consistency"}</h4>
                <p style={styles.smallHelp}>The automatic alcohol assessment is retained unless you edit it. Continue through all three stages to approve; subsequent edits require reconfirmation.</p>
                <div style={{padding:12,borderRadius:8,background:advancedDraft.alcohol.approved?"#e7f5e9":"#eef4fa",marginBottom:12}}>
                  <strong>{advancedDraft.alcohol.approved?"✓ Alcohol interpretation confirmed":"Alcohol review awaiting confirmation"}</strong>
                  <p style={{margin:"6px 0 0",fontSize:13}}>Use the fields below to review the automatic wording or supply expert-approved replacement text.</p>
                </div>
                {advancedPanel==="interpretations" && <>
                <div className="adv-alcohol-board"><div className="adv-eyebrow">ALCOHOL · EXPERT ASSESSMENT</div><p>Review EtG and PEth where instructed and present. These selections are a visual review aid; the detailed approved alcohol wording below remains authoritative and must be updated to reflect your conclusions.</p><div className="adv-alcohol-grid">{[{id:"etg",name:"EtG",help:"Hair / nail alcohol marker"},{id:"peth",name:"PEth",help:"Blood alcohol marker"}].map(marker=><div key={marker.id} className="adv-alcohol-tile"><strong>{marker.name}</strong><small>{marker.help}</small><select value={matrixAlcohol[marker.id]||""} onChange={e=>{setMatrixAlcohol(v=>({...v,[marker.id]:e.target.value}));setSummaryApproved(false);setAdvancedDraft(prev=>({...prev,alcohol:{...prev.alcohol,approved:false}}));}}><option value="">Review marker / not applicable</option><option value="non_excessive">Non-excessive consumption</option><option value="excessive">Excessive consumption</option><option value="low">Low-level consumption</option><option value="abstinence">Abstinence / no evidence</option><option value="inconclusive">Inconclusive</option></select></div>)}</div><p className="adv-note">Selections do not invent test results or overwrite EtG/PEth interpretations automatically. Confirm the wording and period below; the backend still uses the reviewed alcohol interpretation and justification text.</p></div>
                <details style={{marginBottom:12}}><summary style={{cursor:"pointer",fontWeight:650}}>Alcohol summary — optional</summary>
                <div style={styles.overrideGrid}>
                  <label style={styles.field}><span style={styles.label}>Summary consumption level</span><input style={styles.input} value={advancedDraft.alcohol.summary_level||""} onChange={e=>editAdvancedAlcohol({summary_level:e.target.value})} placeholder="e.g. non-excessive, low level"/></label>
                  <label style={styles.field}><span style={styles.label}>Summary approximate period</span><input style={styles.input} value={advancedDraft.alcohol.summary_period||""} onChange={e=>editAdvancedAlcohol({summary_period:e.target.value})} placeholder="e.g. mid-March to late September 2026"/></label>
                </div>
                <label style={{...styles.field,marginTop:10}}><span style={styles.label}>Alcohol summary comment</span><input style={styles.input} value={advancedDraft.alcohol.summary_note||""} onChange={e=>editAdvancedAlcohol({summary_note:e.target.value})}/></label>
                </details>
                <details style={{marginBottom:12}}><summary style={{cursor:"pointer",fontWeight:650}}>Detailed alcohol interpretation — view or edit</summary>
                <textarea style={styles.jsonTextarea} value={advancedDraft.alcohol.interpretation_text||""} onChange={e=>editAdvancedAlcohol({interpretation_text:e.target.value})}/>
                </details>
                </>}
                {advancedPanel==="justifications" && <>
                <h4 style={styles.miniHeading}>Alcohol — justifications</h4>
                <p style={styles.smallHelp}>Review the selected paragraphs. Only include wording supported by the findings.</p>
                <details open style={{marginBottom:12}}><summary style={{cursor:"pointer",fontWeight:650}}>Selected alcohol justifications — view or edit</summary>
                {(advancedDraft.alcohol.justifications||[]).map((j,i)=><div key={i} style={{marginTop:12}}><label style={styles.checkboxLabel}><input type="checkbox" checked={!!j.selected} onChange={e=>editAdvancedAlcohol({justifications:advancedDraft.alcohol.justifications.map((p,k)=>k===i?{...p,selected:e.target.checked}:p)})}/>Alcohol justification {i+1}</label><textarea style={styles.donorTextarea} value={j.text} onChange={e=>editAdvancedAlcohol({justifications:advancedDraft.alcohol.justifications.map((p,k)=>k===i?{...p,text:e.target.value}:p)})}/></div>)}
                </details>
                </>}
                {advancedPanel==="consistency" && <div style={{...styles.autoreportBox,marginTop:18}}>
                  <h4 style={styles.miniHeading}>Alcohol — consistency with declaration</h4>
                  <p style={styles.smallHelp}>Select an optional starting statement or enter your own. The final wording replaces the existing [[alcohol_consistency_text]] field in the Advanced Word report. Confirm it agrees with the approved alcohol interpretation and declarations.</p>
                  <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:12}}>
                    <button type="button" style={styles.secondaryBtn} onClick={()=>editAdvancedAlcohol({consistency_text:`${advancedDraft.client_name||"The client"} did not declare consuming alcohol during the period covered by the samples. This is consistent with my interpretation.`})}>No alcohol declared — consistent (verify)</button>
                    <button type="button" style={styles.secondaryBtn} onClick={()=>editAdvancedAlcohol({consistency_text:`${advancedDraft.client_name||"The client"} did not declare consuming alcohol during the period covered by the samples. This is not consistent with my interpretation.`})}>No alcohol declared — inconsistent (verify)</button>
                    <button type="button" style={styles.secondaryBtn} onClick={()=>editAdvancedAlcohol({consistency_text:`${advancedDraft.client_name||"The client"} declared consuming alcohol at a low level during the period covered by the samples. This is consistent with my interpretation.`})}>Low level declared — consistent (verify)</button>
                    <button type="button" style={styles.secondaryBtn} onClick={()=>editAdvancedAlcohol({consistency_text:`${advancedDraft.client_name||"The client"} declared consuming alcohol in excessive quantities during the period covered by the samples. This is consistent with my interpretation.`})}>Excessive declared — consistent (verify)</button>
                    <button type="button" style={styles.secondaryBtn} onClick={()=>editAdvancedAlcohol({consistency_text:""})}>Clear statement</button>
                  </div>
                  <div style={styles.overrideGrid}>
                    {[{key:"hair_nail_declaration",label:"Hair / nail biomarker table"},{key:"peth_declaration",label:"PEth blood table"}].map(field=><label key={field.key} style={styles.field}>
                      <span style={styles.label}>{field.label} — declaration</span>
                      <select style={styles.input} value={advancedDraft.alcohol[field.key]||""} onChange={e=>editAdvancedAlcohol({[field.key]:e.target.value})}>
                        <option value="">Keep automatic table value</option>
                        <option value="CONSISTENT">CONSISTENT</option>
                        <option value="INCONSISTENT">INCONSISTENT</option>
                        <option value="UNABLE TO ASSESS">UNABLE TO ASSESS</option>
                      </select>
                    </label>)}
                  </div>
                  <p style={styles.smallHelp}>Set hair/nail and PEth independently where both were tested. The appropriate table uses the selected classification; untested markers are not added.</p>
                  <label style={styles.field}>
                    <span style={styles.label}>Expert-approved alcohol consistency (manual input)</span>
                    <textarea style={styles.jsonTextarea} value={advancedDraft.alcohol.consistency_text||""} onChange={e=>editAdvancedAlcohol({consistency_text:e.target.value})} placeholder="Enter the full alcohol consistency paragraph exactly as it should appear in the Word report..." />
                  </label>
                </div>}

              </div>}

              {advancedTab===-2 && <div>
                <h3 style={styles.subTitle}>Final Advanced review</h3>
                <p style={styles.smallHelp}>Check each subject below. All reviews must be approved before generating the Word report. Selecting a subject takes you back to its interpretation step.</p>
                {wizardItems.map(item=><div key={item.id} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:12,borderBottom:"1px solid #d9e2ed",gap:12}}>
                  <strong>{item.label}</strong>
                  <button type="button" style={styles.secondaryBtn} onClick={()=>wizardGo(item.id)}>{item.approved?"✓ Approved · Review again":"Review required"}</button>
                </div>)}
                {!wizardItems.length&&<p>No drugs or alcohol require Advanced review. Standard ND reporting remains automatic.</p>}
                <div style={{marginTop:16,padding:14,border:"1px solid #b8d0e1",borderRadius:12,background:"#f3f8fd"}}>
                  <h4 style={{...styles.miniHeading,margin:"0 0 8px"}}>Final summary — review and approve</h4>
                  <p style={styles.smallHelp}>This replaces the old example summary and includes approved, unchanged drug interpretations and alcohol. Existing substances-not-detected, notification and case considerations are added separately by FTS. Check every classification and period against the detailed interpretation.</p>
                  {summaryManual?<textarea style={{...styles.jsonTextarea,minHeight:260,width:"100%"}} value={summaryTextOverride} onChange={e=>{setSummaryTextOverride(e.target.value);setSummaryApproved(false);}}/>:
                    <div style={{whiteSpace:"pre-wrap",lineHeight:1.6,background:"white",border:"1px solid #dce4ec",borderRadius:8,padding:12,maxHeight:330,overflowY:"auto"}}>{generatedSummaryText||"No summary conclusions available — review original interpretations."}</div>}
                  <div style={{display:"flex",gap:8,marginTop:12,flexWrap:"wrap"}}>
                    <button type="button" style={styles.secondaryBtn} onClick={()=>{if(!summaryManual)setSummaryTextOverride(generatedSummaryText);setSummaryManual(v=>!v);setSummaryApproved(false);}}>{summaryManual?"Use generated summary":"Edit summary wording"}</button>
                    <button type="button" style={{...styles.secondaryBtn,background:summaryApproved?"#d8f3de":"white"}} onClick={()=>{if(!wizardComplete){setAdvancedWizardError("Finish all substance reviews before approving the summary.");return;}if(!finalSummaryText.trim()||finalSummaryText.includes("[CONFIRM ")){setAdvancedWizardError("Confirm the alcohol conclusion and complete the final summary before approval.");return;}setAdvancedWizardError("");setSummaryApproved(true);}}> {summaryApproved?"✓ Summary approved":"Approve this summary"}</button>
                  </div>
                </div>

                <p style={{...styles.smallHelp,marginTop:16}}>The report uses the existing Word templates and table renderer. Verify scientific interpretation before release.</p>
              </div>}
                </div>
                <div style={{padding:"14px 22px",borderTop:"1px solid #dae4ef",background:"#f7f9fc"}}>
                  {(advancedWizardError||error)&&<div role="alert" style={{color:"#991b1b",marginBottom:9,fontSize:13}}>{advancedWizardError||error}</div>}
                  <div style={{display:"flex",justifyContent:"space-between",gap:12,alignItems:"center"}}>
                    <button type="button" style={styles.secondaryBtn} disabled={advancedTab===-3} onClick={wizardBack}>← Back</button>
                    {wizardFinished?
                      <button type="button" style={{...styles.generateBtn,...(busy||!wizardComplete?styles.generateBtnDisabled:{})}} disabled={busy||!wizardSummaryReady} onClick={async()=>{setAdvancedWizardError("");await handleGenerate();}}>{busy?"Generating…":wizardSummaryReady?"Generate Advanced Word document":"Approve the final summary first"}</button>
                      :<button type="button" style={styles.generateBtn} onClick={wizardNext}>{advancedTab===-3?"Review detailed interpretations →":advancedPanel==="consistency"?"Approve & next ✓":"Continue →"}</button>}
                  </div>
                </div>
              </div>
            </div>
          )}
          {error && <div style={styles.error}>{error}</div>}



          <div style={styles.actions}>

            <button

              type="button"

              className="tech-action-button"

              style={{

                ...styles.generateBtn,

                ...(busy ? styles.generateBtnDisabled : {}),

              }}

              onClick={handleGenerate}

              disabled={busy}

            >

              {busy ? "Processing..." : reportType === "normal_case" && ftsMode === "advanced" ? (advancedDraft ? "Open Advanced Expert Review" : "Analyse & Open Expert Review (Beta)") : "Generate Word Document"}

            </button>

          </div>

        </section>



        <section style={styles.card} className="tech-card">

          <h2 style={styles.sectionTitle}>PDF Merge - Blood Fix</h2>



          <p style={styles.helpText}>

            Upload the main report PDF and the blood results PDF. The system

            will create a standardised blood summary page and append it to the

            report.

          </p>



          <div style={styles.formGrid}>

            {bloodOutputStyle === "classic" && (

            <label style={{ ...styles.field, ...styles.fullWidth }}>

              <span style={styles.label}>Main Report PDF</span>



              <input

                style={styles.fileInput}

                type="file"

                accept="application/pdf,.pdf"

                onChange={(e) =>

                  setBloodReportPdf(e.target.files?.[0] || null)

                }

              />

            </label>

            )}





            {bloodOutputStyle === "new_report" && (

              <div

                style={{

                  ...styles.fullWidth,

                  color: "#7f8a9c",

                  fontSize: 13,

                  lineHeight: 1.5,

                }}

              >

                New report style creates a standalone Word document.

                A main report PDF is not required.

              </div>

            )}



            <label style={{ ...styles.field, ...styles.fullWidth }}>

              <span style={styles.label}>Blood Results PDF</span>



              <input

                style={styles.fileInput}

                type="file"

                accept="application/pdf,.pdf"

                onChange={(e) =>

                  setBloodResultsPdf(e.target.files?.[0] || null)

                }

              />

            </label>



            <label style={styles.field}>

              <span style={styles.label}>Blood test type</span>



              <select

                style={styles.input}

                value={bloodTestMode}

                onChange={(e) => setBloodTestMode(e.target.value)}

              >

                <option value="bloods_no_mcv">

                  CDT and LFTs - do not include MCV

                </option>



                <option value="lft_only">

                  LFTs only - no CDT or MCV

                </option>



                <option value="bloods_with_mcv">

                  CDT and LFTs + MCV - include MCV if found

                </option>



                <option value="mcv_only">

                  MCV only

                </option>

              </select>

            </label>



            <label style={styles.field}>

              <span style={styles.label}>Blood summary style</span>



              <select

                style={styles.input}

                value={bloodOutputStyle}

                onChange={(e) => setBloodOutputStyle(e.target.value)}

              >

                <option value="classic">

                  Classic style

                </option>



                <option value="new_report">

                  New report style - Word document only

                </option>

              </select>

            </label>

          </div>



          {bloodError && <div style={styles.error}>{bloodError}</div>}



          <div style={styles.actions}>

            <button

              type="button"

              className="tech-action-button"

              style={{

                ...styles.generateBtn,

                ...(bloodBusy ? styles.generateBtnDisabled : {}),

              }}

              onClick={handleBloodFixGenerate}

              disabled={bloodBusy}

            >

              {bloodBusy ? "Generating..." : "Generate Merged PDF"}

            </button>

          </div>

        </section>

      </div>

    </div>

  );

}



const styles = {

  page: {

    minHeight: "100vh",

    background:

      "radial-gradient(circle at 8% 0%, rgba(0,82,140,0.10), transparent 30%), radial-gradient(circle at 96% 8%, rgba(123,55,89,0.10), transparent 28%), linear-gradient(180deg, #f8fafc 0%, #f3f5f9 100%)",

    padding: "28px 24px 44px",

    boxSizing: "border-box",

    fontFamily: '"Segoe UI Variable", "Aptos", "Segoe UI", Arial, sans-serif',

    color: "#111827",

  },



  shell: {

    maxWidth: 1180,

    margin: "0 auto",

    fontFamily: "inherit",

  },



  topBar: {

    marginBottom: 14,

  },



  backBtn: {

    border: "1px solid rgba(0,82,140,0.18)",

    background: "rgba(255,255,255,0.90)",

    color: "#00528c",

    borderRadius: 12,

    padding: "10px 15px",

    cursor: "pointer",

    fontWeight: 800,

    fontFamily: "inherit",

    boxShadow: "0 4px 14px rgba(15,23,42,0.06)",

    backdropFilter: "blur(8px)",

  },



  hero: {

    position: "relative",

    marginBottom: 24,

    padding: "30px 34px",

    borderRadius: 22,

    background:

      "linear-gradient(120deg, rgba(0,82,140,0.97) 0%, rgba(0,82,140,0.92) 48%, rgba(123,55,89,0.94) 100%)",

    boxShadow: "0 18px 45px rgba(0,82,140,0.20)",

    border: "1px solid rgba(255,255,255,0.18)",

    overflow: "hidden",

  },



  heroAccent: {

    display: "inline-flex",

    alignItems: "center",

    padding: "5px 10px",

    marginBottom: 10,

    borderRadius: 999,

    background: "rgba(255,255,255,0.14)",

    border: "1px solid rgba(255,255,255,0.18)",

    color: "rgba(255,255,255,0.88)",

    textTransform: "uppercase",

    letterSpacing: "0.13em",

    fontSize: 11,

    fontWeight: 900,

  },



  title: {

    margin: 0,

    fontSize: "clamp(34px, 5vw, 48px)",

    lineHeight: 1.02,

    color: "#fff",

    fontFamily: '"Segoe UI Variable Display", "Aptos Display", "Segoe UI", sans-serif',

    fontWeight: 800,

    letterSpacing: "-0.035em",

  },



  heroSubtitle: {

    margin: "10px 0 0",

    maxWidth: 720,

    color: "rgba(255,255,255,0.82)",

    fontSize: 15,

    lineHeight: 1.55,

    fontWeight: 500,

  },



  card: {

    background: "rgba(255,255,255,0.94)",

    borderRadius: 20,

    padding: "30px 32px",

    boxShadow: "0 14px 38px rgba(15,23,42,0.085), 0 2px 8px rgba(15,23,42,0.035)",

    border: "1px solid rgba(203,213,225,0.78)",

    fontFamily: "inherit",

    marginBottom: 24,

    backdropFilter: "blur(10px)",

  },



  sectionTitle: {

    marginTop: 0,

    marginBottom: 7,

    fontSize: 24,

    color: "#7B3759",

    fontFamily: '"Segoe UI Variable Display", "Aptos Display", "Segoe UI", sans-serif',

    fontWeight: 800,

    letterSpacing: "-0.02em",

  },



  helpText: {

    marginTop: 0,

    color: "#5b6474",

    lineHeight: 1.62,

    fontFamily: "inherit",

    maxWidth: 940,

  },



  smallHelp: {

    marginTop: 0,

    color: "#738095",

    lineHeight: 1.5,

    fontSize: 13,

  },



  reportGrid: {

    display: "grid",

    gridTemplateColumns: "repeat(auto-fit, minmax(205px, 1fr))",

    gap: 12,

    marginTop: 22,

    marginBottom: 28,

  },



  reportButton: {

    border: "1px solid #d8dee8",

    background: "linear-gradient(180deg, #ffffff 0%, #fbfcfe 100%)",

    color: "#1f2937",

    borderRadius: 13,

    padding: "15px 16px",

    cursor: "pointer",

    fontWeight: 800,

    textAlign: "center",

    fontFamily: "inherit",

    fontSize: 14,

    boxShadow: "0 3px 10px rgba(15,23,42,0.045)",

  },



  reportButtonActive: {

    background: "linear-gradient(135deg, #c91c1c 0%, #a91616 100%)",

    borderColor: "#c91c1c",

    color: "#fff",

    boxShadow: "0 9px 22px rgba(201,28,28,0.22)",

  },



  formGrid: {

    display: "grid",

    gridTemplateColumns: "repeat(auto-fit, minmax(270px, 1fr))",

    gap: 18,

  },



  overrideGrid: {

    display: "grid",

    gridTemplateColumns: "repeat(auto-fit, minmax(270px, 1fr))",

    gap: 18,

  },



  field: {

    display: "flex",

    flexDirection: "column",

    gap: 7,

    fontFamily: "inherit",

  },



  fullWidth: {

    gridColumn: "1 / -1",

  },



  label: {

    fontWeight: 800,

    color: "#334155",

    fontFamily: "inherit",

    fontSize: 14,

    letterSpacing: "0.005em",

  },



  input: {

    border: "1px solid #d6dde8",

    borderRadius: 11,

    padding: "11px 13px",

    fontSize: 15,

    background: "#fff",

    fontFamily: "inherit",

    minHeight: 44,

    boxShadow: "0 1px 2px rgba(15,23,42,0.025)",

    color: "#172033",

  },



  fileInput: {

    border: "1px dashed rgba(201,28,28,0.52)",

    borderRadius: 12,

    padding: 14,

    background: "linear-gradient(180deg, #fffafa 0%, #fff7f7 100%)",

    fontFamily: "inherit",

    fontSize: 14,

    color: "#475569",

  },



  donorTextarea: {

    width: "100%",

    minHeight: 96,

    resize: "vertical",

    boxSizing: "border-box",

    border: "1px solid #d6dde8",

    borderRadius: 11,

    padding: "12px 13px",

    fontSize: 15,

    lineHeight: 1.5,

    background: "#fff",

    fontFamily: "inherit",

    boxShadow: "0 1px 2px rgba(15,23,42,0.025)",

  },



  jsonTextarea: {

    width: "100%",

    minHeight: 260,

    resize: "vertical",

    boxSizing: "border-box",

    border: "1px solid #d2dbe7",

    borderRadius: 13,

    padding: 15,

    fontFamily: 'Cascadia Code, Consolas, "Courier New", monospace',

    fontSize: 13,

    lineHeight: 1.52,

    background: "#fbfdff",

    boxShadow: "inset 0 1px 2px rgba(15,23,42,0.03)",

  },



  autoreportBox: {

    marginTop: 26,

    border: "1px solid rgba(0,82,140,0.16)",

    borderRadius: 16,

    padding: "22px 22px 20px",

    background: "linear-gradient(180deg, rgba(248,251,254,0.98) 0%, rgba(245,249,252,0.96) 100%)",

    boxShadow: "0 8px 24px rgba(0,82,140,0.055)",

  },



  influenceBox: {

    marginTop: 26,

    border: "1px solid rgba(123,55,89,0.15)",

    borderRadius: 16,

    padding: 20,

    background: "linear-gradient(180deg, #fdfcfd 0%, #faf8fa 100%)",

    boxShadow: "0 8px 24px rgba(123,55,89,0.045)",

    fontFamily: "inherit",

  },



  subTitle: {

    marginTop: 0,

    marginBottom: 12,

    color: "#142033",

    fontFamily: '"Segoe UI Variable Display", "Aptos Display", "Segoe UI", sans-serif',

    fontWeight: 800,

    fontSize: 18,

    letterSpacing: "-0.01em",

  },



  miniHeading: {

    marginTop: 25,

    marginBottom: 12,

    color: "#00528c",

    fontSize: 15,

    fontWeight: 900,

    textTransform: "uppercase",

    letterSpacing: "0.055em",

  },



  checkboxGrid: {

    display: "grid",

    gridTemplateColumns: "repeat(auto-fit, minmax(210px, 1fr))",

    gap: 11,

  },



  checkboxLabel: {

    display: "flex",

    gap: 9,

    alignItems: "center",

    fontWeight: 650,

    color: "#3d485a",

    fontFamily: "inherit",

    padding: "4px 0",

  },



  inlineActions: {

    display: "flex",

    alignItems: "center",

    gap: 14,

    marginTop: 15,

    flexWrap: "wrap",

  },



  secondaryBtn: {

    border: "1px solid rgba(0,82,140,0.44)",

    borderRadius: 11,

    padding: "10px 15px",

    background: "#fff",

    color: "#00528c",

    fontWeight: 850,

    cursor: "pointer",

    fontFamily: "inherit",

    boxShadow: "0 3px 10px rgba(0,82,140,0.06)",

  },



  successText: {

    color: "#166534",

    fontWeight: 750,

    padding: "6px 10px",

    borderRadius: 9,

    background: "#f0fdf4",

    border: "1px solid #dcfce7",

  },



  error: {

    marginTop: 20,

    background: "linear-gradient(180deg, #fff1f2 0%, #fee2e2 100%)",

    color: "#991b1b",

    padding: "13px 14px",

    borderRadius: 11,

    border: "1px solid #fecaca",

    boxShadow: "0 5px 14px rgba(153,27,27,0.06)",

    fontWeight: 750,

    fontFamily: "inherit",

    whiteSpace: "pre-wrap",

  },



  actions: {

    marginTop: 27,

    display: "flex",

    justifyContent: "flex-end",

  },



  generateBtn: {

    border: "1px solid rgba(123,55,89,0.92)",

    borderRadius: 12,

    padding: "13px 20px",

    background: "linear-gradient(135deg, #7B3759 0%, #622b48 100%)",

    color: "#fff",

    fontWeight: 900,

    cursor: "pointer",

    fontSize: 15,

    fontFamily: "inherit",

    boxShadow: "0 9px 20px rgba(123,55,89,0.20)",

  },



  generateBtnDisabled: {

    opacity: 0.62,

    cursor: "not-allowed",

    boxShadow: "none",

  },

};
